import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//third party
import {
  Observable,
  Subject,
  BehaviorSubject,
  ReplaySubject,
  Subscription,
  catchError,
  firstValueFrom,
  lastValueFrom,
  map,
  shareReplay,
  switchMap,
  tap,
  throwError,
  timer,
  of,
} from 'rxjs';
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import * as Papa from 'papaparse'; // for csv parsing
import * as ExcelJS from 'exceljs';

// import { xmlbuilder } from 'xmlbuilder';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
// components
import { AddEditUsersComponent } from 'src/app/account-info/modals/add-edit-users/add-edit-users.component';
import { CreateProductServiceComponent } from '../modals/create-product-service/create-product-service.component';
import { EditBbAcquisitionComponent } from '../modals/edit-bb-acquisition/edit-bb-acquisition.component';
import { EditBbDispositionComponent } from '../modals/edit-bb-disposition/edit-bb-disposition.component';
import { EditBbFirearmComponent } from '../modals/edit-bb-firearm/edit-bb-firearm.component';
import { FirearmInfoDashComponent } from '../components/firearm-info-dash/firearm-info-dash.component';
import { MessageComponent } from '../modals/message/message.component';
import { YesNoComponent } from '../modals/yes-no/yes-no.component';
import { ImportByCategoryComponent } from 'src/app/accounting/products-services/modals/import-by-category/import-by-category.component';
import { UserCredentialsComponent } from '../modals/user-credentials/user-credentials.component';
import { InventorySearchComponent } from '../modals/inventory-search/inventory-search.component';

// services
import { LocalDatabaseService } from './local-database.service';
import { NetworkSyncService } from './network-sync.service';
import { InactivityService } from './inactivity.service';

// models
import {
  EmailType,
  ModalID,
  ModalType,
  Roles,
  setup_feature_mapping,
  SetupTaskId,
  Statements,
} from '../models/constants';
import { environment } from 'src/environments/environment';
import { DispoList } from 'src/app/dispositions/disposition/models';
import {
  AddEditFirearmResponse,
  FFL,
  Firearm,
  BoundBook,
  BoundBookEntry,
  EventEntry,
  AddEditFFLResponse,
  Form4473,
  QuestionResponse,
  AvailableFirearm,
  FileInfo,
  UpdatedBoundBookResult,
  ReservedFirearm,
  Form4473Transferee,
  ReservedInputs,
  BuildDisposition,
  Form4473Transferor,
  ManualEnteredId,
  CapturedSignature,
  Email,
} from '../models/general';
import { QuestionnaireIntoComponent } from 'src/app/form-4473/modals/questionnaire-into/questionnaire-into.component';
import { DigitalSignatureComponent } from '../modals/digital-signature/digital-signature.component';
import {
  AutofillForm3310,
  CompanyInfo,
  Master,
  User,
  loginAccount,
} from '../models/company';
import {
  Customer,
  ProductServiceItem,
  SalesItem,
  SalesReceipt,
  Vendor,
} from '../models/accounting';
import { ChoiceComponent } from '../modals/choice/choice.component';
import { AddEditContactComponent } from 'src/app/accounting/modals/add-edit-contact/add-edit-contact.component';
// Components
import { BoundBookPrintComponent } from '../../bound-book/bound-book-print/bound-book-print.component';
import { SalesReceiptPdfGenerator } from 'src/app/accounting/sales-receipt-print/create-sales-receipt-pdf';
import { SalesReceiptPrintComponent } from 'src/app/accounting/sales-receipt-print/sales-receipt-print.component';
import { SerialNumberListComponent } from '../modals/serial-number-list/serial-number-list.component';
import { ScanIdComponent } from '../modals/scan-id/scan-id.component';
import { LiveVendorData } from '../models/vendor';
import { InventoryOptionsComponent } from '../modals/inventory-options/inventory-options.component';
import { OptimizerItemComponent } from '../modals/optimizer-item/optimizer-item.component';
import { InventoryAlert, AutoPurchase } from '../models/general';
import { FflSearchComponent } from '../modals/ffl-search/ffl-search.component';
import { AtfFfl } from '../models/atf-ffl';
import { DriverLicense } from '../models/drivers-license-parser';
import { FirearmManagementEditComponent } from 'src/app/firearms/firearm-management/modals/firearm-management-edit/firearm-management-edit.component';
import { DriversLicenseSelectionComponent } from '../modals/drivers-license-selection/drivers-license-selection.component';
import { DuplicateTtsnComponent } from '../modals/duplicate-ttsn/duplicate-ttsn.component';
import { CompetitorPricingComponent } from 'src/app/vendor-data/vendor-dashboard/modals/competitor-pricing/competitor-pricing.component';
import { DispoBuildComponent } from '../modals/dispo-build/dispo-build.component';
import { EnterIdComponent } from '../modals/enter-id/enter-id.component';
import { KioskSelectionComponent } from 'src/app/kiosk/modals/kiosk-selection/kiosk-selection.component';
import { CreateForm3310Component } from '../modals/create-form-3310/create-form-3310.component';
import { FflManagementEditComponent } from 'src/app/ffl/ffl-management/modals/ffl-management-edit/ffl-management-edit.component';
import { EmailComponent } from '../modals/email/email.component';
import { TextModalComponent } from '../modals/text-modal/text-modal.component';
import { FflPackingSlipPrintComponent } from 'src/app/dispositions/ffl-packing-slip-print/ffl-packing-slip-print.component';
import { AddBoundBookComponent } from '../modals/add-bound-book/add-bound-book.component';
import { InventoryAlertsComponent } from '../modals/inventory-alerts/inventory-alerts.component';

export interface CachedDocumentResult {
  document: string | null;
  file_name: string | null;
  file_size_kb: number | null;
  updatedAt: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class SharedService implements OnDestroy {
  apiUrl: string = environment.apiUrl;
  usps_url: string =
    'http://production.shippingapis.com/ShippingAPI.dll?API=CityStateLookup"';
  ffl_ezCheck_url: string = 'https://www.atfonline.gov/fflezcheck/fflSearch.do';

  loggedInUser: User = new User();
  logged_in_user: User = new User();
  environment: string = 'test';

  private kiosk_mode_subject = new BehaviorSubject<boolean>(false);
  kiosk_mode$ = this.kiosk_mode_subject.asObservable();

  get kiosk_mode(): boolean {
    return this.kiosk_mode_subject.getValue();
  }

  set kiosk_mode(value: boolean) {
    this.kiosk_mode_subject.next(value);
  }

  form_4473_version = '08-01-2023';
  file_size_limit = 20000000; // 2MB
  private _loading$ = new BehaviorSubject<boolean>(false);
  private _loading_message$ = new BehaviorSubject<string>('Loading...');

  get loading$(): BehaviorSubject<boolean> { return this._loading$; }
  get loading_message$(): BehaviorSubject<string> { return this._loading_message$; }

  get loading(): boolean { return this._loading$.value; }
  set loading(value: boolean) { this._loading$.next(value); }

  get loading_message(): string { return this._loading_message$.value; }
  set loading_message(value: string) { this._loading_message$.next(value); }
  default_pagination_page_size: number = 100;
  selected_boundbook: {
    boundbook_id: string | null;
    boundbook_name: string | null;
  } = {
    boundbook_id: null,
    boundbook_name: null,
  };
  available_boundbooks: {
    boundbook_id: string;
    boundbook_name: string;
    default: boolean;
  }[] = [];
  public connection_status$: Subject<boolean> = new Subject<boolean>();
  private pollSubscription: Subscription;

  constructor(
    private router: Router,
    private http: HttpClient,
    private modalService: BsModalService,
    private toast: ToastrService,
    private localDb: LocalDatabaseService,
    public networkSync: NetworkSyncService,
    private inactivityService: InactivityService,
  ) {
    // Register callback so inactivity logout runs the same cleanup as the
    // explicit Log Out button — see signOutCleanup().
    this.inactivityService.registerClearUser(() => this.signOutCleanup());
    // Start polling server status
    this.pollSubscription = timer(0, 30000).subscribe(() => {
      this.checkServerConnection();
    });
  }

  ngOnDestroy(): void {
    if (this.pollSubscription) {
      this.pollSubscription.unsubscribe();
    }
  }

  checkServerConnection() {
    // Avoid backend polling before authentication.
    if (!this.logged_in_user?.user_id) {
      return;
    }

    this.http.get(this.apiUrl + '/health').subscribe({
      next: () => {
        this.connection_status$.next(true);
      },
      error: () => {
        this.connection_status$.next(false);
      },
    });
  }

  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  modalOptions: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    class: 'modal-dialog  modal-dialog-centered',
  } as any;

  // modal subjects
  yes_no_submit$: Subject<any> = new Subject();
  option_selected$: Subject<QuestionResponse> = new Subject();
  status_message_changed$: Subject<any> = new Subject();
  message_viewed$: Subject<any> = new Subject();
  master_file_created$: Subject<Master> = new Subject();
  master_file_retrieved$: Subject<Master> = new Subject();
  bound_book_retrieved$: ReplaySubject<any> = new ReplaySubject(1);
  bound_book_updated$: Subject<UpdatedBoundBookResult> = new Subject();
  firearm_list_retrieved$: ReplaySubject<any> = new ReplaySubject(1);
  firearm_list_updated$: Subject<Firearm[]> = new Subject();
  inventory_search_item_selected$: Subject<any> = new Subject();
  reserved_firearm_list_updated$: Subject<ReservedFirearm[]> = new Subject();
  reserved_firearm_list_retrieved$: Subject<ReservedFirearm[]> = new Subject();
  firearm_selected$: Subject<BoundBookEntry> = new Subject();
  firearm_to_add$: Subject<AddEditFirearmResponse> = new Subject();
  firearm_to_edit$: Subject<BoundBookEntry> = new Subject();
  ffl_list_retrieved$: Subject<any> = new Subject();
  ffl_to_add$: Subject<AddEditFFLResponse> = new Subject();
  ffl_selected$: Subject<FFL> = new Subject();
  ffl_list_updated$: Subject<FFL[]> = new Subject();
  signatureCaptured$: Subject<CapturedSignature> = new Subject();
  user_to_add_or_edit$: Subject<{}> = new Subject();
  view_edit_item$: Subject<any> = new Subject();
  user_updated$: Subject<User[]> = new Subject();
  user_added$: Subject<User[]> = new Subject();
  file_selected_from_picker$: Subject<FileInfo> = new Subject();
  status_change$: Subject<string> = new Subject();
  file_verified$: Subject<{ file: File; import_type: string }> = new Subject();
  delete_serial$: Subject<{ itemIndex: number; serialIndex: number }> =
    new Subject();
  drivers_license_scanned$: Subject<DriverLicense> = new Subject();
  company_info_retrieved$: ReplaySubject<CompanyInfo> = new ReplaySubject(1);
  reset_4473_buyer$: Subject<boolean> = new Subject();
  reserve_firearm_list_updated$: Subject<ReservedFirearm[]> = new Subject();
  reserve_firearm_inputs_captured$: Subject<ReservedInputs> = new Subject();
  clear_bulk_acquisition_rows$: Subject<number> = new Subject();
  reserve_firearm_inputs_canceled$: Subject<ReservedInputs> = new Subject();
  reserved_firearm_selected$: ReplaySubject<number> = new ReplaySubject(1);
  reserved_4473_transferee_selected$: Subject<Form4473Transferee> =
    new Subject();
  boundbook_selected$: Subject<BoundBook> = new Subject();
  seller_form_4473_saved$: Subject<Boolean> = new Subject();
  drivers_license_id_selected$: Subject<string> = new Subject();
  proceed_with_duplicate_ttsn$: Subject<boolean> = new Subject();
  manual_id_entered$: Subject<boolean> = new Subject(); // not used right now
  kiosk_selection_made$: Subject<string> = new Subject();
  private pdfOverlayClosedSource = new Subject<void>();
  public pdfOverlayClosed$ = this.pdfOverlayClosedSource.asObservable();
  /** Emitted after a Form 3310.4 email is successfully sent from the email modal. */
  email_sent$ = new Subject<{
    email_type: string;
    form4473_id?: string;
    pending3310_id?: string;
  }>();
  calendar_events$ = new BehaviorSubject<any[]>([]);

  // variables
  selected_rows: DispoList[] = [];
  selected_firearms_for_disposition: DispoList[] = [];
  master: Master = new Master();
  company_info: CompanyInfo = new CompanyInfo();
  /** True only after company_info has been populated from a real fetch (network or cache),
   *  so UI can avoid acting on the empty initial CompanyInfo() instance. */
  company_info_loaded = false;
  all_bound_books: BoundBook[] = [];
  bound_book: BoundBookEntry[] = [];
  available_firearms_for_dispo: AvailableFirearm[] = [];
  recent_drivers_license: DriverLicense[] = [];
  example_posts: any[] = [];
  ffl_list: FFL[] = [];
  last_ffls_used: FFL[] = [];
  ffls_frequently_used: FFL[] = [];
  atf_ffl_list: AtfFfl[] = [];
  firearm_list: Firearm[] = [];
  reserved_firearm_list: ReservedFirearm[] = [];
  reserved_4473_list: Form4473Transferee[] = [];
  build_disposition: BuildDisposition = new BuildDisposition();
  users: User[] = [];
  error = null;
  form_4473: Form4473;
  categories: string[] = [
    'Shipping',
    'Office Supplies',
    'Rent',
    'Utilities',
    'Meals & Entertainment',
    'Travel',
    'Advertising',
    'Insurance',
    'Legal & Professional Services',
    'Repairs & Maintenance',
    'Other',
  ];
  pending_4473: Form4473 = new Form4473();
  /** Cached list of incomplete Form 4473 drafts fetched from the server. */
  incomplete_4473_records: Form4473[] = [];
  /** List of pending Form 3310.4 reminder records fetched from the server. */
  pending_3310_records: any[] = [];
  item_data: LiveVendorData[] = []; // used for vendor dashboard component
  all_live_vendor_data: LiveVendorData[] = [];
  parsed_license: DriverLicense = new DriverLicense();
  selected_reservation_id: number | null = null;
  // dispo build variables
  dispo_build_modal_shown: boolean = false;
  dispo_build_reserved_firearms: ReservedFirearm[] = [];
  dispo_build_selected_drivers_license: DriverLicense = new DriverLicense();
  dispo_build_manual_entered_id: ManualEnteredId = new ManualEnteredId();
  dispo_build_selected_transferee_4473: Form4473Transferee =
    new Form4473Transferee();
  dispo_build_seller_4473: Form4473Transferor = new Form4473Transferor();
  /// make the rest of the variables
  extensionInstalled = false;
  distinct_manufacture_list: string[] = [];
  distinct_firearm_calibers: string[] = [];
  distinct_manufacture_models: string[] = [];

  startAppAtLogin(page: string) {
    setTimeout(() => {
      console.log(this.router.url);
      if (this.router.url === '/') {
        this.router.navigate([page]);
        // this.router.navigate(['acquisition']);
      } else if (this.router.url !== '/login') {
        this.router.navigate([page]);
      }
    }, 500);
  }

  async addEventRecord(eventDetails: EventEntry) {
    // create an event record function
  }

  // general functions
  async getCityState(
    zipcode: string,
  ): Promise<{ cities: string[]; state: string } | null> {
    try {
      const dbResults = await this.getZipCodeData(zipcode);
      if (dbResults && dbResults.length > 0) {
        // Return unique cities and the state (assuming state is the same for all)
        const cities = Array.from(
          new Set<string>(dbResults.map((res: any) => String(res.city_name))),
        ).sort();
        return {
          cities,
          state: dbResults[0].state_abbreviation,
        };
      }
      return null;
    } catch (err) {
      console.error('Zip lookup failed:', err);
      return null;
    }
  }

  async getZipCodeData(zipcode: string) {
    try {
      const response = await firstValueFrom(
        this.http.get<{ message: string; data: any }>(
          `${this.apiUrl}/zip_codes/${zipcode}`,
        ),
      );
      return response.data;
    } catch (error: any) {
      if (error.status === 404) {
        return null; // Silently return null if not in our DB
      }
      console.error('Error fetching zip code from database:', error);
      return null;
    }
  }
  public createUuid() {
    return uuid();
  }
  // createEventRecord(original_values: any, updated_values: any, event: string) {
  //   let event_entry = new EventEntry();
  //   event_entry.username = this.loggedInUser.username;
  //   event_entry.event = 'Edit Firearm';
  //   event_entry.value_changed_from = original_values;
  //   event_entry.value_changed_to = updated_values;
  //   event_entry.date_time_stamp = createDateTimeStamp();
  //   // this.createEventRecord(event_entry);
  // }

  verifyFfl(ffl: string) {
    // not working
    //
    let values = new HttpParams();
    values = values.append('licsRegn', '9');
    values = values.append('licsDis', '82');
    values = values.append('licsSeq', '02610');
    console.log(ffl);

    this.http
      .get(this.ffl_ezCheck_url, { params: values })
      .subscribe((response) => {
        console.warn(response);
      });
  }

  getSingleBoundBookEntry(firearm_id: number) {
    return this.bound_book.find((entry) => entry.firearm_id === firearm_id);
  }

  checkEmailExists(email: string): Observable<{ exists: boolean }> {
    return this.http.post<{ exists: boolean }>(`${this.apiUrl}/auth/check-email`, { email });
  }

  //-----------Master CRUD Functions MongoDB-----------------
  addNewMasterRecord(new_master_record: Master) {
    this.http
      .post<{
        message: string;
        masterId: string;
      }>(`${this.apiUrl}/masters`, new_master_record)
      .subscribe({
        next: (response) => {
          new_master_record.company_id = response.masterId;
          this.master = new_master_record;
          this.master_file_created$.next(this.master);
        },
        error: (error) => {
          console.error('Error:', error);
        },
      });
  }
  // getMasterRecordById(master_id: string) {
  //   this.http
  //     .get<{ message: string; masterRecord: Master }>(
  //       `${this.apiUrl}/masters/${master_id}`
  //     )
  //     .subscribe((response) => {
  //       this.master.company_id = master_id;
  //       this.master.company = response['company'];
  //       this.master.accounting = response['accounting'];
  //       this.master.ffl_list = response['ffl_list'];
  //       this.master.firearm_list = response['firearm_list'];
  //       this.master.bound_book = response['bound_book'];
  //       this.master_file_retrieved$.next(this.master);
  //     });
  // }
  getMasterRecordById(master_id: string): Observable<Master> {
    return this.http
      .get<{
        message: string;
        masterRecord: Master;
      }>(`${this.apiUrl}/masters/${master_id}`)
      .pipe(
        map((response) => {
          this.master.company_id = master_id;
          this.master.company = response['company'];
          this.master.accounting = response['accounting'];
          this.master.ffl_list = response['ffl_list'];
          this.master.firearm_list = response['firearm_list'];
          this.master.bound_book = response['bound_book'];
          return this.master;
        }),
      );
  }
  //-----------Login CRUD Functions MongoDB-----------------
  addNewLoginAccount(new_user: loginAccount) {
    this.http
      .post<{
        message: string;
        userId: string;
      }>(`${this.apiUrl}/logins`, new_user)
      .subscribe({
        next: (response) => {
          console.warn(response);
          this.raiseSuccessToast('login account created');
          // this.user_to_add_or_edit$.next(this.master.company.users);
        },
        error: (error) => {
          console.error('Error:', error);
        },
      });
  }

  //-----------Bound Book CRUD Functions MongoDB-----------------
  // Working with MongoDB
  async addBoundBookEntry(entry: BoundBookEntry): Promise<void> {
    try {
      if (!this.selected_boundbook.boundbook_id) {
        throw new Error('No bound book selected');
      }
      entry.updatedAt = new Date().toISOString();
      // Optimistic add in memory
      this.bound_book = [...this.bound_book, entry];
      const updated_bound_book: UpdatedBoundBookResult =
        new UpdatedBoundBookResult();
      updated_bound_book.bound_book_id = this.selected_boundbook.boundbook_id;
      updated_bound_book.bound_book = [...this.bound_book];
      this.bound_book_updated$.next(updated_bound_book);
      // Update cached book entries in IndexedDB
      const cachedBook = await this.localDb.boundBooks.get(
        this.selected_boundbook.boundbook_id || '',
      );
      if (cachedBook) {
        cachedBook.entries = this.bound_book;
        await this.localDb.boundBooks.put(cachedBook);
      }
      // Queue POST for when online
      await this.networkSync.queueOperation(
        'POST',
        `${this.apiUrl}/bound_books`,
        { ...entry, bound_book_id: this.selected_boundbook.boundbook_id },
      );
      if (this.networkSync.isOnline) {
        // queueOperation kicks off the actual HTTP POST in the background; wait
        // for the queue to drain before refetching, otherwise the GET races and
        // returns the list without the new entry (overwriting the optimistic add).
        await this.networkSync.waitForSync();
        // Refresh to get server-assigned _id
        await this.getBoundBookEntries();
      }
    } catch (error) {
      console.error('Error adding bound book entry:', error);
    }
  }
  async getBoundBookEntries(preferCache = false): Promise<void> {
    if (preferCache) {
      const localBooks = await this.localDb.boundBooks
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.all_bound_books = localBooks;
      this.createBoundBookSelectionList();
      if (this.available_boundbooks.length > 0) {
        const defaultBook = this.available_boundbooks.find((b) => b.default) || this.available_boundbooks[0];
        const selectedBook = localBooks.find((b) => b.bound_book_id === defaultBook.boundbook_id);
        this.bound_book = selectedBook?.entries || [];
        this.selected_boundbook = defaultBook;
      }
      this.bound_book_retrieved$.next(this.bound_book);
      return;
    }
    try {
      const response = await firstValueFrom(
        this.http.get<{ message: string; boundBook: BoundBook[] }>(
          `${this.apiUrl}/bound_books`,
        ),
      );
      this.all_bound_books = response.boundBook;
      // Cache locally for offline use — clear stale records first so server-deleted books are removed
      await this.localDb.boundBooks
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .delete();
      await this.localDb.boundBooks.bulkPut(
        this.all_bound_books.filter((b) => b._id),
      );
      this.createBoundBookSelectionList();

      // If a book is selected, fetch the associated entries
      if (this.selected_boundbook.boundbook_id) {
        const listMatch = this.available_boundbooks.find(
          (b) => b.boundbook_id === this.selected_boundbook.boundbook_id,
        );
        await this.updateSelectedBoundBook(
          listMatch || this.selected_boundbook,
        );
      } else if (this.available_boundbooks.length > 0) {
        // Default to first book if none selected
        await this.updateSelectedBoundBook(
          this.available_boundbooks.find((b) => b.default === true) || this.available_boundbooks[0],
        );
      }

      this.bound_book_retrieved$.next(this.bound_book);
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for bound books...',
        error,
      );
      const localBooks = await this.localDb.boundBooks
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.all_bound_books = localBooks;
      this.createBoundBookSelectionList();
      if (this.available_boundbooks.length > 0) {
        const defaultBook =
          this.available_boundbooks.find((b) => b.default) ||
          this.available_boundbooks[0];
        // Restore entries from whichever book was selected (entries are stored on the book object)
        const selectedBook = localBooks.find(
          (b) => b.bound_book_id === defaultBook.boundbook_id,
        );
        this.bound_book = selectedBook?.entries || [];
        this.selected_boundbook = defaultBook;
      }
      this.bound_book_retrieved$.next(this.bound_book);
      if (localBooks.length === 0) {
        this.toast.error(
          'You are offline and no bound book data is cached yet.',
        );
      }
    }
  }

  async addBoundBook(bound_book: BoundBook): Promise<void> {
    bound_book.company_id = this.company_info.company_id;
    // Assign a temporary client-side ID so we can cache it offline
    if (!bound_book.bound_book_id) {
      bound_book.bound_book_id = uuid();
    }

    // Optimistic: add to in-memory list immediately
    this.all_bound_books.push(bound_book);
    this.createBoundBookSelectionList();
    this.selected_boundbook = {
      boundbook_id: bound_book.bound_book_id,
      boundbook_name: bound_book.bound_book_name,
    };
    this.bound_book = [];
    this.bound_book_retrieved$.next(this.bound_book);

    // Persist to IndexedDB so it survives a page reload while offline
    await this.localDb.boundBooks.put(bound_book);

    if (this.networkSync.isOnline) {
      try {
        const response = await firstValueFrom(
          this.http.post<{ message: string; boundBookId: string }>(
            `${this.apiUrl}/bound_books/new`,
            bound_book,
          ),
        );
        // Update the book with the real server-assigned ID
        const serverBookId = response.boundBookId;
        await this.localDb.boundBooks.delete(bound_book.bound_book_id);
        bound_book.bound_book_id = serverBookId;
        await this.localDb.boundBooks.put(bound_book);
        const idx = this.all_bound_books.findIndex(
          (b) => b.bound_book_id === this.selected_boundbook.boundbook_id,
        );
        if (idx !== -1) {
          this.all_bound_books[idx].bound_book_id = serverBookId;
        }
        this.selected_boundbook.boundbook_id = serverBookId;
        this.createBoundBookSelectionList();
        this.raiseSuccessToast('Bound Book created successfully');
      } catch (error) {
        console.error('Error creating bound book:', error);
        this.raiseErrorToast('Failed to create bound book');
      }
    } else {
      // Queue the POST for when connectivity returns; pass tempId so the sync
      // service can rewrite any subsequent PUT/PATCH ops if an edit is made
      // against this record while still offline.
      await this.networkSync.queueOperation(
        'POST',
        `${this.apiUrl}/bound_books/new`,
        bound_book,
        bound_book.bound_book_id,
      );
    }
  }

  async renameBoundBook(bookId: string, newName: string): Promise<void> {
    // Update local state immediately regardless of connectivity
    const book = this.all_bound_books.find((b) => b.bound_book_id === bookId);
    if (book) {
      book.bound_book_name = newName;
    }
    if (this.selected_boundbook.boundbook_id === bookId) {
      this.selected_boundbook.boundbook_name = newName;
    }
    this.createBoundBookSelectionList();

    await this.networkSync.queueOperation(
      'PATCH',
      `${this.apiUrl}/bound_books/${bookId}/name`,
      { name: newName },
    );
    if (this.networkSync.isOnline) {
      this.raiseSuccessToast('Bound Book renamed successfully');
    }
  }

  async setDefaultBoundBook(bookId: string): Promise<void> {
    // Update local state immediately regardless of connectivity
    this.all_bound_books.forEach((b) => {
      b.default = b.bound_book_id === bookId;
    });
    this.createBoundBookSelectionList();

    await this.networkSync.queueOperation(
      'PATCH',
      `${this.apiUrl}/bound_books/${bookId}/default`,
      {},
    );
    if (this.networkSync.isOnline) {
      this.raiseSuccessToast('Default bound book updated');
    }
  }

  async updateSelectedBoundBook(selection: any): Promise<void> {
    this.selected_boundbook = selection;
    if (selection && selection.boundbook_id) {
      const selectedBook = this.all_bound_books.find(
        (b) => b.bound_book_id === selection.boundbook_id,
      );

      try {
        const response = await firstValueFrom(
          this.http.get<{ message: string; entries: BoundBookEntry[] }>(
            `${this.apiUrl}/bound_books/${selection.boundbook_id}/entries`,
          ),
        );
        this.bound_book = response.entries || [];
      } catch (error) {
        console.error('Error fetching entries for selected bound book:', error);
        this.bound_book = [];
      }

      this.boundbook_selected$.next(selectedBook || null);
    } else {
      this.bound_book = [];
      this.boundbook_selected$.next(null);
    }
  }

  createBoundBookSelectionList() {
    this.available_boundbooks = this.all_bound_books.map((book) => ({
      boundbook_id: book.bound_book_id,
      boundbook_name: book.bound_book_name,
      default: book.default,
    }));

    if (
      this.available_boundbooks.length === 1 &&
      !this.selected_boundbook.boundbook_id
    ) {
      this.selected_boundbook = this.available_boundbooks[0];
    }
  }
  async getBoundBookEntryById(bound_book_id: string): Promise<BoundBookEntry> {
    const response = await firstValueFrom(
      this.http
        .get<{
          message: string;
          boundBookEntry: any;
        }>(`${this.apiUrl}/bound_books/${bound_book_id}`)
        .pipe(
          map((response) => {
            return {
              ...response.boundBookEntry,
            } as BoundBookEntry;
          }),
        ),
    );
    return response;
  }
  async getBoundBookEntryByFirearmId(
    firearm_id: number,
  ): Promise<BoundBookEntry | null> {
    try {
      const response = await firstValueFrom(
        this.http
          .get<{
            message: string;
            boundBookEntry: any;
          }>(`${this.apiUrl}/bound_books/firearm/${firearm_id}`)
          .pipe(
            map((response) => {
              if (!response.boundBookEntry) {
                return null;
              }

              return {
                ...response.boundBookEntry,
              } as BoundBookEntry;
            }),
          ),
      );

      return response;
    } catch (error: any) {
      if (error.status === 404) {
        console.warn(
          `Bound book entry not found for firearm_id: ${firearm_id}`,
        );
        return null;
      }
      console.error('Error fetching bound book entry by firearm_id:', error);
      this.raiseErrorToast('Failed to retrieve bound book entry');
      throw error;
    }
  }
  async getBoundBookEntryByFirearmIdEnhanced(
    firearm_id: number,
    bound_book_name: string,
    company_id: string,
  ): Promise<BoundBookEntry | null> {
    try {
      let params = new HttpParams()
        .set('company_id', company_id)
        .set('bound_book_name', bound_book_name);

      const response = await firstValueFrom(
        this.http
          .get<{
            message: string;
            boundBookEntry: any;
          }>(`${this.apiUrl}/bound_books/firearm/${firearm_id}`, {
            params: params,
          })
          .pipe(
            map((response) => {
              if (!response.boundBookEntry) {
                return null;
              }

              return {
                ...response.boundBookEntry,
              } as BoundBookEntry;
            }),
          ),
      );

      return response;
    } catch (error: any) {
      if (error.status === 404) {
        console.warn(
          `Bound book entry not found for firearm_id: ${firearm_id}`,
        );
        return null;
      }
      console.error('Error fetching bound book entry by firearm_id:', error);
      this.raiseErrorToast('Failed to retrieve bound book entry');
      throw error;
    }
  }
  async updateBoundBookEntry(
    updateBoundBookEntry: BoundBookEntry,
  ): Promise<void> {
    if (!updateBoundBookEntry._id) {
      throw new Error('Bound book entry ID not found');
    }

    updateBoundBookEntry.updatedAt = new Date().toISOString();
    // Optimistic update in memory
    this.bound_book = this.bound_book.map((entry) =>
      entry._id === updateBoundBookEntry._id ? updateBoundBookEntry : entry,
    );
    const updated_bound_book = new UpdatedBoundBookResult();
    updated_bound_book.bound_book_id = this.selected_boundbook.boundbook_id;
    updated_bound_book.bound_book = [...this.bound_book];
    this.bound_book_updated$.next(updated_bound_book);
    // Update cached book entries in IndexedDB
    const cachedBook = await this.localDb.boundBooks.get(
      this.selected_boundbook.boundbook_id || '',
    );
    if (cachedBook) {
      cachedBook.entries = this.bound_book;
      await this.localDb.boundBooks.put(cachedBook);
    }

    if (this.networkSync.isOnline) {
      await firstValueFrom(
        this.http.put(
          `${this.apiUrl}/bound_books/${updateBoundBookEntry._id}`,
          updateBoundBookEntry,
        ),
      );
      return;
    }

    await this.networkSync.queueOperation(
      'PUT',
      `${this.apiUrl}/bound_books/${updateBoundBookEntry._id}`,
      updateBoundBookEntry,
    );
  }
  async findMaxTransactionSerialNumber(): Promise<string> {
    try {
      const response = await firstValueFrom(
        this.http.get<{ message: string }>(
          `${this.apiUrl}/bound_books/max-d-form4473`,
        ),
      );
      return response.message;
    } catch (error: any) {
      if (error && error.status === 404) {
        return '0';
      }
      console.error('Error finding max transaction serial number:', error);
      throw error;
    }
  }
  // not sure if needed
  async deleteBoundBookEntry(id: string): Promise<void> {
    // Optimistic delete in memory
    this.bound_book = this.bound_book.filter((entry) => entry._id !== id);
    const updated_bound_book: UpdatedBoundBookResult =
      new UpdatedBoundBookResult();
    updated_bound_book.bound_book_id = this.selected_boundbook.boundbook_id;
    updated_bound_book.bound_book = [...this.bound_book];
    this.bound_book_updated$.next(updated_bound_book);
    // Update cached book entries in IndexedDB
    const cachedBook = await this.localDb.boundBooks.get(
      this.selected_boundbook.boundbook_id || '',
    );
    if (cachedBook) {
      cachedBook.entries = this.bound_book;
      await this.localDb.boundBooks.put(cachedBook);
    }
    // Queue DELETE for when online
    await this.networkSync.queueOperation(
      'DELETE',
      `${this.apiUrl}/bound_books/${id}`,
    );
  }
  // check if 4473 value is in use
  async check4473Value(
    value: string,
  ): Promise<{ exists: boolean; message: string }> {
    try {
      const response = await firstValueFrom(
        this.http.get<any>(
          `${this.apiUrl}/bound_books/check-d-form4473/${value}`,
        ),
      );
      return response;
    } catch (error) {
      console.error('Error checking 4473 value:', error);
      throw error; // Re-throw the error to be handled by the caller
    }
  }
  async generate4473Id(): Promise<string> {
    if (!this.networkSync.isOnline) {
      // Return empty string — the real number will be assigned at sync time
      // to guarantee chronological ordering across all offline submissions.
      return '';
    }
    try {
      const url = `${this.apiUrl}/bound_books/max-d-form4473`;
      const response = await firstValueFrom(
        this.http.get<{ message: string }>(url),
      );
      return (+response.message + 1).toString();
    } catch (error: any) {
      if (error && error.status === 404) {
        return '1';
      }
      console.error('Error getting max 4473 ID value:', error);
      throw error;
    }
  }
  // * POST /api/form_4473s - Create a new Form 4473
  async addForm4473(form4473: Form4473): Promise<void> {
    const isOffline = !this.networkSync.isOnline;
    const needsTransactionId = isOffline && !form4473.transaction_serial_number;

    if (isOffline && !form4473._id) {
      form4473._id = uuid();
    }

    // Optimistic: set as pending immediately
    this.pending_4473 = form4473;

    if (isOffline) {
      // Queue POST — if offline with no transfer number, flag it for deferred assignment at sync time.
      await this.networkSync.queueOperation(
        'POST',
        `${this.apiUrl}/form_4473s`,
        form4473,
        form4473._id,
        needsTransactionId,
      );
    }

    if (this.networkSync.isOnline) {
      try {
        const response = await firstValueFrom(
          this.http.post<Form4473>(`${this.apiUrl}/form_4473s`, form4473),
        );
        this.pending_4473._id = response._id;
        if (!this.pending_4473._id) {
          throw new Error('Form 4473 was created without a valid _id response');
        }
        // Remove from queue (already executed)
        await this.localDb.form4473s.put({ ...this.pending_4473 });
        this.raiseSuccessToast('Form 4473 successfully created');
      } catch (error) {
        console.error('Error creating Form 4473:', error);
        this.raiseErrorToast('Failed to create Form 4473');
        throw error;
      }
    } else {
      // Persist offline copy (transfer number will be blank until sync)
      await this.localDb.form4473s.put({ ...form4473 });
    }
  }
  // * GET /api/form_4473s/company/:companyId - Get all Form 4473 records for a company
  async getForm4473ByCompanyId(companyId: string, preferCache = false): Promise<Form4473[]> {
    if (preferCache) {
      return this.localDb.form4473s.where('company_id').equals(companyId).toArray();
    }
    try {
      const response = await firstValueFrom(
        this.http.get<Form4473[]>(
          `${this.apiUrl}/form_4473s/company/${companyId}`,
        ),
      );
      // Cache locally for offline use — clear stale records first so server-deleted items are removed
      const toCache = response.filter((f) => f._id);
      if (toCache.length > 0) {
        await this.localDb.form4473s
          .where('company_id')
          .equals(companyId)
          .delete();
        await this.localDb.form4473s.bulkPut(toCache);
      }
      return response;
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for Form 4473...',
        error,
      );
      const local = await this.localDb.form4473s
        .where('company_id')
        .equals(companyId)
        .toArray();
      return local;
    }
  }
  // * GET /api/form_4473s/:id * Get a single Form 4473 by MongoDB _id and company_id
  async getForm4473ByTransactionSerial(
    transactionSerial: string,
  ): Promise<Form4473 | null> {
    try {
      const companyId = this.company_info.company_id;
      if (!companyId) {
        this.raiseErrorToast('Company ID not found');
        return null;
      }

      const response = await firstValueFrom(
        this.http.get<Form4473>(
          `${this.apiUrl}/form_4473s/${transactionSerial}?company_id=${companyId}`,
        ),
      );
      return response;
    } catch (error: any) {
      if (error.status === 404) {
        console.warn('Form 4473 not found:', transactionSerial);
        return null;
      }
      console.error('Error fetching Form 4473:', error);
      this.raiseErrorToast('Failed to retrieve Form 4473');
      throw error;
    }
  }
  // * GET /api/form_4473s/company/:companyId/incomplete * Get all Form 4473 records for a company that are incomplete
  async getIncompleteForm4473ByCompanyId(
    companyId: string,
  ): Promise<Form4473[]> {
    try {
      const response = await firstValueFrom(
        this.http.get<Form4473[]>(
          `${this.apiUrl}/form_4473s/company/${companyId}/incomplete`,
        ),
      );
      this.incomplete_4473_records = response || [];
      return response;
    } catch (error) {
      console.error('Error fetching incomplete Form 4473 records:', error);
      this.raiseErrorToast('Failed to retrieve incomplete Form 4473 records');
      throw error;
    }
  }
  // * PUT /api/form_4473s/:id * Update a Form 4473 by MongoDB _id
  async updateForm4473(form4473: Form4473): Promise<void> {
    if (!form4473._id) {
      this.raiseErrorToast('Form 4473 ID not found');
      return;
    }
    form4473.updatedAt = new Date().toISOString();
    // Optimistic update in memory and IndexedDB
    if (this.pending_4473._id === form4473._id) {
      this.pending_4473 = { ...form4473 };
    }
    await this.localDb.form4473s.put({ ...form4473 });
    // Queue PUT for when online
    await this.networkSync.queueOperation(
      'PUT',
      `${this.apiUrl}/form_4473s/id/${form4473._id}`,
      form4473,
    );
    if (this.networkSync.isOnline) {
      this.raiseSuccessToast('Form 4473 successfully updated');
    }
  }
  // * DELETE /api/form_4473s/:id * Delete a Form 4473 by MongoDB _id and company_id
  async deleteForm4473(id: string): Promise<void> {
    const companyId = this.company_info.company_id;
    if (!companyId) {
      this.raiseErrorToast('Company ID not found');
      return;
    }

    // Optimistic: remove from IndexedDB and clear pending_4473 if it matches
    await this.localDb.form4473s.delete(id);
    if (this.pending_4473?._id === id) {
      this.pending_4473 = new Form4473();
    }

    const deleteUrl = `${this.apiUrl}/form_4473s/id/${id}?company_id=${companyId}`;

    if (this.networkSync.isOnline) {
      try {
        await firstValueFrom(
          this.http.delete<{ message: string; deletedCount: number }>(
            deleteUrl,
          ),
        );
      } catch (error: any) {
        if (error.status === 404) {
          this.raiseErrorToast('Form 4473 not found');
        } else {
          this.raiseErrorToast('Failed to delete Form 4473');
        }
        console.error('Error deleting Form 4473:', error);
        throw error;
      }
    } else {
      await this.networkSync.queueOperation('DELETE', deleteUrl);
    }
  }

  //-----------Reserved Firearms CRUD Functions MongoDB-----------------
  async addFirearmToReservedList(reserved_items: ReservedFirearm[]) {
    if (this.company_info.company_id) {
      reserved_items.forEach(
        (item) => (item.company_id = this.company_info.company_id),
      );
    }
    // Optimistic add in memory and IndexedDB
    this.reserved_firearm_list = [
      ...this.reserved_firearm_list,
      ...reserved_items,
    ];
    for (const item of reserved_items) {
      if (item._id) {
        await this.localDb.reservedFirearms.put(item);
      }
    }
    // Queue POST for when online
    await this.networkSync.queueOperation(
      'POST',
      `${this.apiUrl}/reserved_firearms`,
      reserved_items,
    );
    if (this.networkSync.isOnline) {
      // Refresh to get server-assigned _ids
      await this.getReservedFirearmList();
      if (reserved_items.length > 1) {
        this.raiseSuccessToast('Firearms successfully reserved');
      } else {
        this.raiseSuccessToast('Firearm successfully reserved');
      }
    }
  }
  async getReservedFirearmList(preferCache = false): Promise<void> {
    if (preferCache) {
      const localItems = await this.localDb.reservedFirearms
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.reserved_firearm_list = localItems;
      this.reserved_firearm_list_retrieved$.next(this.reserved_firearm_list);
      return;
    }
    try {
      let params = new HttpParams().set(
        'company_id',
        this.company_info.company_id || '',
      );
      if (this.selected_boundbook?.boundbook_id) {
        params = params.set(
          'bound_book_id',
          this.selected_boundbook.boundbook_id,
        );
      }
      const response = await firstValueFrom(
        this.http
          .get<{
            message: string;
            reservedItems: ReservedFirearm[];
          }>(`${this.apiUrl}/reserved_firearms`, { params })
          .pipe(map((res) => res.reservedItems.map((entry) => ({ ...entry })))),
      );
      this.reserved_firearm_list = response;
      this.reserved_firearm_list_retrieved$.next(this.reserved_firearm_list);
      // Cache locally for offline use — clear stale records first, scoped to the queried bound book (or whole company)
      const toCache = response.filter((r) => r._id);
      if (toCache.length > 0) {
        if (this.selected_boundbook?.boundbook_id) {
          await this.localDb.reservedFirearms
            .where('bound_book_id')
            .equals(this.selected_boundbook.boundbook_id)
            .delete();
        } else {
          await this.localDb.reservedFirearms
            .where('company_id')
            .equals(this.company_info.company_id || '')
            .delete();
        }
        await this.localDb.reservedFirearms.bulkPut(toCache);
      }
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for reserved firearms...',
        error,
      );
      let query = this.localDb.reservedFirearms
        .where('company_id')
        .equals(this.company_info.company_id || '');
      const localItems = await query.toArray();
      this.reserved_firearm_list = localItems;
      this.reserved_firearm_list_retrieved$.next(this.reserved_firearm_list);
    }
  }
  async deleteFirearmFromReserveList(reservation_id: number): Promise<void> {
    if (
      reservation_id === null ||
      reservation_id === undefined ||
      Number.isNaN(Number(reservation_id))
    ) {
      console.warn(
        'Skipping reserved firearm delete due to invalid reservation_id:',
        reservation_id,
      );
      return;
    }

    // Remove from in-memory list and IndexedDB immediately (optimistic)
    this.reserved_firearm_list = this.reserved_firearm_list.filter(
      (item) => item.reservation_id !== reservation_id,
    );
    this.reserved_firearm_list_retrieved$.next(this.reserved_firearm_list);
    await this.localDb.reservedFirearms
      .filter((item) => item.reservation_id === reservation_id)
      .delete();

    if (this.networkSync.isOnline) {
      await firstValueFrom(
        this.http.delete(`${this.apiUrl}/reserved_firearms/${reservation_id}`),
      );
    } else {
      await this.networkSync.queueOperation(
        'DELETE',
        `${this.apiUrl}/reserved_firearms/${reservation_id}`,
      );
    }
  }

  //-----------Reserved 4473's CRUD Functions MongoDB-----------------
  async add4473ToReservedList(reserved_4473: Form4473Transferee) {
    reserved_4473.company_id = this.company_info.company_id;
    console.warn(reserved_4473);
    this.http
      .post<{
        message: string;
        entryId: string;
      }>(`${this.apiUrl}/reserved_4473s`, reserved_4473)
      .subscribe({
        next: (response) => {
          reserved_4473.id = response.entryId;
          this.reserved_4473_list.push(reserved_4473);
          this.reserved_4473_list = [...this.reserved_4473_list];
          // this.reserve_4473_list_updated$.next([...this.reserved_4473_list]);
          this.raiseSuccessToast('4473 successfully reserved');
        },
        error: (error) => {
          console.error('Error:', error);
          this.raiseErrorToast(error);
        },
      });
  }
  async getReserved4473List(preferCache = false): Promise<void> {
    if (preferCache) {
      this.reserved_4473_list = await this.localDb.reserved4473s
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      return;
    }
    try {
      let params = new HttpParams().set(
        'company_id',
        this.company_info.company_id || '',
      );
      const response = await firstValueFrom(
        this.http
          .get<{
            message: string;
            reserved4473Entries: any[];
          }>(`${this.apiUrl}/reserved_4473s`, { params })
          .pipe(
            map((response) => {
              return response.reserved4473Entries.map((entry) => {
                return {
                  id: entry._id,
                  company_id: entry.company_id,
                  name_first: entry.name_first,
                  name_middle: entry.name_middle,
                  name_last: entry.name_last,
                  address_street: entry.address_street,
                  address_zip_code: entry.address_zip_code,
                  address_city: entry.address_city,
                  address_state: entry.address_state,
                  address_county: entry.address_county,
                  birth_country: entry.birth_country,
                  birth_state: entry.birth_state,
                  birth_city: entry.birth_city,
                  height_feet: entry.height_feet,
                  height_inches: entry.height_inches,
                  weight: entry.weight,
                  sex: entry.sex,
                  birth_year: entry.birth_year,
                  birth_month: entry.birth_month,
                  birth_day: entry.birth_day,
                  social_security: entry.social_security,
                  upin: entry.upin,
                  ethnicity: entry.ethnicity,
                  race: entry.race,
                  citizenship: entry.citizenship,
                  alien_prefix: entry.alien_prefix,
                  alien_number: entry.alien_number,
                  question_a: entry.question_a,
                  question_b: entry.question_b,
                  question_c: entry.question_c,
                  question_d: entry.question_d,
                  question_e: entry.question_e,
                  question_f: entry.question_f,
                  question_g: entry.question_g,
                  question_h: entry.question_h,
                  question_i: entry.question_i,
                  question_j: entry.question_j,
                  question_k: entry.question_k,
                  question_l1: entry.question_l1,
                  question_l2: entry.question_l2,
                  transferee_cert: entry.transferee_cert,
                  transferee_cert_month: entry.transferee_cert_month,
                  transferee_cert_day: entry.transferee_cert_day,
                  transferee_cert_year: entry.transferee_cert_year,
                  transferee_cert_signature: entry.transferee_cert_signature,
                  transferee_recert_month: entry.transferee_recert_month,
                  transferee_recert_day: entry.transferee_recert_day,
                  transferee_recert_year: entry.transferee_recert_year,
                  transferee_recert_signature:
                    entry.transferee_recert_signature,
                };
              });
            }),
          ),
      );
      this.reserved_4473_list = response;
      this.reserved_4473_list = [...this.reserved_4473_list];
      // Cache locally — purge stale records first so server-deleted entries are removed
      await this.localDb.reserved4473s
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .delete();
      await this.localDb.reserved4473s.bulkPut(
        this.reserved_4473_list.filter((e) => e.id),
      );
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for reserved 4473 list...',
        error,
      );
      const local = await this.localDb.reserved4473s
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.reserved_4473_list = local;
    }
  }
  async deleteReserved4473(
    reserved_4473_to_delete: Form4473Transferee,
  ): Promise<void> {
    // Optimistic: remove from in-memory list and IndexedDB immediately
    this.reserved_4473_list = this.reserved_4473_list.filter(
      (item) => item.id !== reserved_4473_to_delete.id,
    );
    if (reserved_4473_to_delete.id) {
      await this.localDb.reserved4473s.delete(reserved_4473_to_delete.id);
    }
    if (reserved_4473_to_delete.id) {
      await this.networkSync.queueOperation(
        'DELETE',
        `${this.apiUrl}/reserved_4473s/${reserved_4473_to_delete.id}`,
      );
    }
  }
  async updateReserved4473Entry(
    reserved: Form4473Transferee,
  ): Promise<Form4473Transferee | null> {
    reserved.company_id = this.company_info.company_id;
    reserved.updatedAt = new Date().toISOString();

    // Optimistic: update in-memory and IndexedDB immediately
    this.reserved_4473_list = this.reserved_4473_list.map((item) =>
      item.id === reserved.id ? reserved : item,
    );
    if (reserved.id) {
      await this.localDb.reserved4473s.put(reserved);
    }

    // Queue PUT for server sync
    await this.networkSync.queueOperation(
      'PUT',
      `${this.apiUrl}/reserved_4473s/${reserved.id}`,
      reserved,
    );
    return reserved;
  }
  async getReserved4473ById(id: string): Promise<Form4473Transferee | null> {
    try {
      let params = new HttpParams().set(
        'company_id',
        this.company_info.company_id || '',
      );
      const response = await firstValueFrom(
        this.http.get<{ message: string; entry: any }>(
          `${this.apiUrl}/reserved_4473s/${encodeURIComponent(id)}`,
          { params },
        ),
      );

      const entry = response?.entry;
      if (!entry) return null;

      const mapped: Form4473Transferee = {
        id: entry._id ?? entry.id ?? '',
        company_id: entry.company_id,
        name_first: entry.name_first ?? '',
        name_middle: entry.name_middle ?? '',
        name_last: entry.name_last ?? '',
        address_street: entry.address_street ?? '',
        address_zip_code: entry.address_zip_code ?? '',
        address_city: entry.address_city ?? '',
        address_state: entry.address_state ?? '',
        address_county: entry.address_county ?? '',
        birth_country: entry.birth_country ?? '',
        birth_state: entry.birth_state ?? '',
        birth_city: entry.birth_city ?? '',
        height_feet: entry.height_feet ?? '',
        height_inches: entry.height_inches ?? '',
        weight: entry.weight ?? '',
        sex: entry.sex ?? '',
        birth_year: entry.birth_year ?? '',
        birth_month: entry.birth_month ?? '',
        birth_day: entry.birth_day ?? '',
        social_security: entry.social_security ?? '',
        upin: entry.upin ?? '',
        ethnicity: entry.ethnicity ?? '',
        race: entry.race ?? '',
        citizenship: entry.citizenship ?? '',
        alien_prefix: entry.alien_prefix ?? '',
        alien_number: entry.alien_number ?? '',
        question_a: entry.question_a ?? false,
        question_b: entry.question_b ?? false,
        question_c: entry.question_c ?? false,
        question_d: entry.question_d ?? false,
        question_e: entry.question_e ?? false,
        question_f: entry.question_f ?? false,
        question_g: entry.question_g ?? false,
        question_h: entry.question_h ?? false,
        question_i: entry.question_i ?? false,
        question_j: entry.question_j ?? false,
        question_k: entry.question_k ?? false,
        question_l1: entry.question_l1 ?? false,
        question_l2: entry.question_l2 ?? false,
        transferee_cert: entry.transferee_cert ?? false,
        transferee_cert_month: entry.transferee_cert_month ?? '',
        transferee_cert_day: entry.transferee_cert_day ?? '',
        transferee_cert_year: entry.transferee_cert_year ?? '',
        transferee_cert_signature: entry.transferee_cert_signature ?? '',
        transferee_recert_month: entry.transferee_recert_month ?? '',
        transferee_recert_day: entry.transferee_recert_day ?? '',
        transferee_recert_year: entry.transferee_recert_year ?? '',
        transferee_recert_signature: entry.transferee_recert_signature ?? '',
      } as Form4473Transferee;

      return mapped;
    } catch (error) {
      console.error('Error fetching reserved 4473 entry by id:', error);
      return null;
    }
  }

  //-----------Firearm CRUD Functions MongoDB-----------------

  //-----------Firearm CRUD Functions MongoDB-----------------
  async addFirearmToAvailabilityList(firearm_entry: Firearm) {
    firearm_entry.company_id = this.company_info.company_id;
    // Optimistic: add to local state and IndexedDB immediately
    this.firearm_list = [...this.firearm_list, firearm_entry];
    this.firearm_list_updated$.next([...this.firearm_list]);
    if (firearm_entry.id) {
      await this.localDb.firearms.put(firearm_entry);
    }
    // Queue for server sync
    await this.networkSync.queueOperation(
      'POST',
      `${this.apiUrl}/firearms`,
      firearm_entry,
      firearm_entry.id,
    );
    if (this.networkSync.isOnline) {
      // queueOperation kicks off the actual HTTP POST in the background; wait
      // for the queue to drain before refetching, otherwise the GET races and
      // returns the list without the new record (overwriting the optimistic add).
      await this.networkSync.waitForSync();
      // Refresh from server once synced to get the real server-assigned id
      await this.getFirearmList();
    }
  }
  async getFirearmList(preferCache = false) {
    if (preferCache) {
      this.firearm_list = await this.localDb.firearms
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.firearm_list_retrieved$.next(this.firearm_list);
      return;
    }
    let params = new HttpParams().set(
      'company_id',
      this.company_info.company_id || '',
    );
    try {
      const response = await firstValueFrom(
        this.http.get<{ message: string; firearm_list: any[] }>(
          `${this.apiUrl}/firearms`,
          { params },
        ),
      );
      this.firearm_list = response.firearm_list.map((entry) => ({
        id: entry._id,
        company_id: entry.company_id,
        firearm_upc: entry.firearm_upc,
        firearm_type: entry.firearm_type,
        manufacture: entry.manufacture,
        importer: entry.importer,
        model: entry.model,
        additional_markings: entry.additional_markings,
        caliber_gauge: entry.caliber_gauge,
      }));
      this.firearm_list_retrieved$.next(this.firearm_list);
      // Cache locally for offline use — clear stale records first so server-deleted items are removed
      await this.localDb.firearms
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .delete();
      await this.localDb.firearms.bulkPut(this.firearm_list);
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for firearms...',
        error,
      );
      const localFirearms = await this.localDb.firearms
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.firearm_list = localFirearms;
      this.firearm_list_retrieved$.next(this.firearm_list);
      if (localFirearms.length === 0) {
        this.toast.error('You are offline and no firearm data is cached yet.');
      }
    }
  }
  async editFirearm(firearm_to_edit: Firearm): Promise<void> {
    firearm_to_edit.company_id = this.company_info.company_id;
    firearm_to_edit.updatedAt = new Date().toISOString();
    // Optimistic update in memory and IndexedDB
    this.firearm_list = this.firearm_list.map((e) =>
      e.id === firearm_to_edit.id ? firearm_to_edit : e,
    );
    this.firearm_list_updated$.next([...this.firearm_list]);
    await this.localDb.firearms.put(firearm_to_edit);
    // Queue PUT for when online
    await this.networkSync.queueOperation(
      'PUT',
      `${this.apiUrl}/firearms/${firearm_to_edit.id}`,
      firearm_to_edit,
    );
  }
  async deleteFirearm(firearm_to_delete: Firearm) {
    // Optimistic delete in memory and IndexedDB
    this.firearm_list = this.firearm_list.filter(
      (f) => f.id !== firearm_to_delete.id,
    );
    this.firearm_list_updated$.next([...this.firearm_list]);
    await this.localDb.firearms.delete(firearm_to_delete.id);
    // Queue DELETE for when online
    await this.networkSync.queueOperation(
      'DELETE',
      `${this.apiUrl}/firearms/${firearm_to_delete.id}`,
    );
    if (this.networkSync.isOnline) {
      this.raiseSuccessToast(Statements.firearm_successfully_deleted);
    }
  }

  //-----------FFL CRUD Functions MongoDB-----------------
  async addFFLToAvailabilityList(ffl: FFL) {
    ffl.company_id = this.company_info.company_id;
    // Optimistic: add to local state and IndexedDB immediately
    this.ffl_list = [...this.ffl_list, ffl];
    this.ffl_list_updated$.next([...this.ffl_list]);
    if (ffl.id) {
      await this.localDb.ffls.put(ffl);
    }
    // Queue for server sync
    await this.networkSync.queueOperation(
      'POST',
      `${this.apiUrl}/ffls`,
      ffl,
      ffl.id,
    );
    if (this.networkSync.isOnline) {
      // queueOperation kicks off the actual HTTP POST in the background; wait
      // for the queue to drain before refetching, otherwise the GET races and
      // returns the list without the new record (overwriting the optimistic add).
      await this.networkSync.waitForSync();
      // Refresh from server once synced to get the real server-assigned id
      await this.getFFLList();
      this.raiseSuccessToast(Statements.ffl_successfully_added);
    }
  }
  async getFFLList(preferCache = false) {
    if (preferCache) {
      this.ffl_list = await this.localDb.ffls
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.ffl_list_retrieved$.next(this.ffl_list);
      return;
    }
    this.ffl_list = [];
    let params = new HttpParams().set(
      'company_id',
      this.company_info.company_id || '',
    );
    try {
      const response = await firstValueFrom(
        this.http.get<{ message: string; ffl_list: any[] }>(
          `${this.apiUrl}/ffls`,
          { params },
        ),
      );
      this.ffl_list = response.ffl_list.map((entry) => ({
        id: entry._id,
        company_id: entry.company_id,
        ffl: entry.ffl,
        legal_name: entry.legal_name,
        business_name: entry.business_name,
        phone_number: entry.phone_number,
        email: entry.email,
        notes: entry.notes,
        expiration_date: entry.expiration_date,
        certified_ffl_blob_name: entry.certified_ffl_blob_name,
      }));
      this.ffl_list_retrieved$.next(this.ffl_list);
      // Cache locally for offline use — clear stale records first so server-deleted items are removed
      await this.localDb.ffls
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .delete();
      await this.localDb.ffls.bulkPut(this.ffl_list);
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for FFLs...',
        error,
      );
      const localFFLs = await this.localDb.ffls
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.ffl_list = localFFLs;
      this.ffl_list_retrieved$.next(this.ffl_list);
      if (localFFLs.length === 0) {
        this.toast.error('You are offline and no FFL data is cached yet.');
      }
    }
  }

  async uploadCertifiedFflPdf(fflId: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('pdf', file);
    return firstValueFrom(
      this.http.post(`${this.apiUrl}/certified_ffls/${fflId}`, formData)
    );
  }

  async parseFflDocument(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return firstValueFrom(
      this.http.post(`${this.apiUrl}/ffls/parse`, formData)
    );
  }

  async getCertifiedFflPdfUrl(fflId: string): Promise<string> {
    const response = await firstValueFrom(
      this.http.get<{ url: string }>(`${this.apiUrl}/certified_ffls/${fflId}`)
    );
    return response.url;
  }

  async deleteCertifiedFflPdf(fflId: string): Promise<any> {
    return firstValueFrom(
      this.http.delete(`${this.apiUrl}/certified_ffls/${fflId}`)
    );
  }

  async editFFL(ffl_to_edit: FFL) {
    ffl_to_edit.company_id = this.company_info.company_id;
    ffl_to_edit.updatedAt = new Date().toISOString();
    // Optimistic update in memory and IndexedDB
    this.ffl_list = this.ffl_list.map((e) =>
      e.id === ffl_to_edit.id ? ffl_to_edit : e,
    );
    this.ffl_list_updated$.next([...this.ffl_list]);
    await this.localDb.ffls.put(ffl_to_edit);
    // Queue PUT for when online
    await this.networkSync.queueOperation(
      'PUT',
      `${this.apiUrl}/ffls/${ffl_to_edit.id}`,
      ffl_to_edit,
    );
    if (this.networkSync.isOnline) {
      this.raiseSuccessToast(Statements.ffl_successfully_updated);
    }
  }
  async deleteFFL(ffl_to_delete: FFL) {
    // Optimistic delete in memory and IndexedDB
    this.ffl_list = this.ffl_list.filter((f) => f.id !== ffl_to_delete.id);
    this.ffl_list_updated$.next([...this.ffl_list]);
    await this.localDb.ffls.delete(ffl_to_delete.id);
    // Queue DELETE for when online
    await this.networkSync.queueOperation(
      'DELETE',
      `${this.apiUrl}/ffls/${ffl_to_delete.id}`,
    );
    if (this.networkSync.isOnline) {
      this.raiseSuccessToast(Statements.ffl_successfully_deleted);
    }
  }

  //-----------Company Info CRUD Functions MongoDB-----------------
  async saveCompanyInformation(company: CompanyInfo): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post<{ message: string; company_info: CompanyInfo }>(
          `${this.apiUrl}/company_profiles`,
          company,
        ),
      );
      this.raiseSuccessToast(Statements.company_info_successfully_updated);
    } catch (error) {
      console.error('Error:', error);
      this.raiseErrorToast(error);
      throw error;
    }
  }
  async updateCompanyInformation(company: CompanyInfo): Promise<void> {
    try {
      const id = company.company_id || (company as any)._id;

      await firstValueFrom(
        this.http.put<{ message: string; company_info: CompanyInfo }>(
          `${this.apiUrl}/company_profiles/${id}`,
          company,
        ),
      );

      // Update IndexedDB after successful PUT
      await this.localDb.companyProfiles.put(company);

      this.raiseSuccessToast(Statements.company_info_successfully_updated);
    } catch (error) {
      console.error('Error updating company info:', error);
      this.raiseErrorToast('Failed to update company information');
      throw error;
    }
  }
  private logoDataUriCache: { source: string; dataUri: string } | null = null;

  /**
   * Resolves the company logo to a data URI. jsPDF needs real bytes, but a
   * blob-backed logo arrives as a SAS URL — fetched here with the native fetch
   * so the auth interceptor doesn't attach an Authorization header to Azure.
   * Returns '' when there is no logo or it can't be retrieved.
   */
  async getCompanyLogoDataUri(): Promise<string> {
    const source = this.company_info?.company_logo;
    if (!source) return '';
    if (source.startsWith('data:')) return source;
    if (this.logoDataUriCache?.source === source) return this.logoDataUriCache.dataUri;

    try {
      const response = await fetch(source);
      if (!response.ok) return '';
      const blob = await response.blob();
      const dataUri = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      this.logoDataUriCache = { source, dataUri };
      return dataUri;
    } catch {
      console.warn('Could not resolve company logo for PDF embedding.');
      return '';
    }
  }

  /** Uploads the company logo to blob storage. Returns a short-lived SAS URL. */
  async uploadCompanyLogo(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('logo', file);
    const res = await firstValueFrom(
      this.http.post<{ url: string; blob_name: string }>(
        `${this.apiUrl}/company_documents/logo`,
        formData,
      ),
    );
    return res.url;
  }

  async deleteCompanyLogo(): Promise<void> {
    await firstValueFrom(
      this.http.delete(`${this.apiUrl}/company_documents/logo`),
    );
  }

  /** Uploads an FFL or SOT PDF to blob storage. Returns a URL plus the metadata shown in the preview card. */
  async uploadCompanyDocument(
    documentType: 'ffl' | 'sot',
    file: File,
  ): Promise<{ url: string; file_name: string; file_size_kb: number; updatedAt: string }> {
    const formData = new FormData();
    formData.append('pdf', file);
    return firstValueFrom(
      this.http.post<{ url: string; file_name: string; file_size_kb: number; updatedAt: string }>(
        `${this.apiUrl}/company_documents/${documentType}`,
        formData,
      ),
    );
  }

  async deleteCompanyDocument(documentType: 'ffl' | 'sot'): Promise<void> {
    await firstValueFrom(
      this.http.delete(`${this.apiUrl}/company_documents/${documentType}`),
    );
    await this.localDb.companyDocuments
      .delete(`${this.company_info.company_id}_${documentType}`)
      .catch(() => undefined);
  }

  async getCompanyInformation() {
    try {
      const response = await firstValueFrom(
        this.http.get<{
          message: string;
          company_profile: any;
        }>(`${this.apiUrl}/company_profiles`),
      );

      const companyData = response.company_profile[0];

      // Transform users to have consistent ID fields
      if (companyData.users && Array.isArray(companyData.users)) {
        companyData.users = companyData.users.map((user: any) => {
          // Handle both ObjectId format and string format
          const userId =
            user.user_id?.$oid || user.user_id || user._id?.$oid || user._id;

          return {
            ...user,
            id: userId, // Map to id field
            user_id: userId, // Ensure user_id is always a string
            _id: userId, // Keep _id for compatibility
          };
        });
      }

      const transformedCompany = {
        ...companyData,
        company_id: companyData._id, // Transform _id to company_id
      };

      // Fetch logo separately to keep the main company_profile response small
      try {
        const logoResponse = await firstValueFrom(
          this.http.get<{ logo: string }>(
            `${this.apiUrl}/company_profiles/logo/${transformedCompany.company_id}`,
          ),
        );
        transformedCompany.company_logo = logoResponse.logo;
      } catch (e: any) {
        if (e?.status !== 404) {
          console.warn('Could not fetch company logo:', e);
        }
      }

      this.company_info = transformedCompany;
      this.users = transformedCompany.users || [];
      this.company_info_loaded = true;
      this.company_info_retrieved$.next(this.company_info);

      await this.localDb.companyProfiles.put(transformedCompany);

      return transformedCompany;
    } catch (error) {
      console.warn('Network fetch failed, falling back to IndexedDB...', error);
      const localCompany = await this.localDb.companyProfiles.toArray();
      if (localCompany.length > 0) {
        const currentCompanyId = (this.logged_in_user as any)?.company_id;
        const matched = localCompany.find((company: any) => {
          const cachedCompanyId = company.company_id || company._id;
          return (
            currentCompanyId &&
            String(cachedCompanyId) === String(currentCompanyId)
          );
        });
        if (matched) {
          this.company_info = matched;
          this.users = this.company_info.users || [];
          this.company_info_loaded = true;
          this.company_info_retrieved$.next(this.company_info);
          return this.company_info;
        }
      }
      this.toast.error('You are offline and no local data is cached yet.');
      this.company_info_retrieved$.next(this.company_info);
      return this.company_info;
    }
  }

  async dismissOnboarding(): Promise<void> {
    try {
      await firstValueFrom(
        this.http.patch(
          `${this.apiUrl}/company_profiles/dismiss-onboarding`,
          {},
        ),
      );
      if (this.company_info) {
        this.company_info.onboarding_dismissed = true;
      }
    } catch (e) {
      console.warn('Failed to dismiss onboarding:', e);
    }
  }

  /** Number of *required* setup tasks still incomplete.
   *  Used by the sidenav badge — only counts the 3 must-do items so
   *  optional tasks (SOT, logo, etc.) never keep the button alive for accounts
   *  that simply don't need them. */
  get setupTasksRemaining(): number {
    const info = this.company_info;
    if (!info || info.onboarding_dismissed) return 0;
    const opts = info.accounting_options;
    const requiredChecks = [
      (info.live_inv_selected_distributors?.length ?? 0) > 0,
      !!opts?.costing_method_for_inventory,
      (opts?.sales_tax_options?.length ?? 0) > 0,
    ];
    return requiredChecks.filter((c) => !c).length;
  }
  get recommendedTasksRemaining(): number {
    const info = this.company_info;
    if (!this.company_info_loaded || !info) return 0;

    const templates = info.email_templates || {};
    const hasEmailTemplate = Object.values(templates).some(
      (t: any) => t?.subject?.trim() || t?.body?.trim(),
    );

    const recommendedChecks = [
      !!info.autofill_form_3310?.agency_name,
      !!info.company_logo,
      !!info.ffl_document,
      !!info.sot_document,
      hasEmailTemplate,
    ];

    return recommendedChecks.filter((c) => !c).length;
  }
  private normalizeFeatureKey(value: string): string {
    return String(value ?? '')
      .trim()
      .toLowerCase();
  }

  private isSetupTaskComplete(taskId: SetupTaskId): boolean {
    const info = this.company_info;
    const opts = info?.accounting_options;
    if (!info || info.onboarding_dismissed) {
      return true;
    }

    switch (taskId) {
      case 'live-inventory':
        return (info.live_inv_selected_distributors?.length ?? 0) > 0;
      case 'costing-method':
        return !!opts?.costing_method_for_inventory;
      case 'sales-tax':
        return (opts?.sales_tax_options?.length ?? 0) > 0;
      case 'form-3310':
        return !!info.autofill_form_3310?.agency_name;
      case 'logo':
        return !!info.company_logo;
      case 'ffl':
        return !!info.ffl_document;
      case 'sot':
        return !!info.sot_document;
      case 'email-templates': {
        const templates = info.email_templates || {};
        return Object.values(templates).some(
          (t: any) => t?.subject?.trim() || t?.body?.trim(),
        );
      }
      default:
        return true;
    }
  }

  getFeatureDisabledReason(group: string, name: string): string | null {
    const g = this.normalizeFeatureKey(group);
    const n = this.normalizeFeatureKey(name);
    const requirements = setup_feature_mapping.filter((entry) => {
      return (
        this.normalizeFeatureKey(entry.group) === g &&
        this.normalizeFeatureKey(entry.name) === n
      );
    });

    if (requirements.length === 0) {
      return null;
    }

    // Check each requirement and return the first incomplete one's reason
    for (const req of requirements) {
      if (!this.isSetupTaskComplete(req.requiredTaskId)) {
        return req.disabledReason;
      }
    }

    return null;
  }

  canUseFeature(group: string, name: string): boolean {
    return !this.getFeatureDisabledReason(group, name);
  }

  private inflightFflPromise: Promise<CachedDocumentResult> | null = null;
  async getFFLDocument(companyId: string): Promise<CachedDocumentResult> {
    if (this.inflightFflPromise) return this.inflightFflPromise;
    this.inflightFflPromise = this.getCachedCompanyDocument(companyId, 'ffl');
    try {
      return await this.inflightFflPromise;
    } finally {
      this.inflightFflPromise = null;
    }
  }

  private inflightSotPromise: Promise<CachedDocumentResult> | null = null;
  async getSOTDocument(companyId: string): Promise<CachedDocumentResult> {
    if (this.inflightSotPromise) return this.inflightSotPromise;
    this.inflightSotPromise = this.getCachedCompanyDocument(companyId, 'sot');
    try {
      return await this.inflightSotPromise;
    } finally {
      this.inflightSotPromise = null;
    }
  }

  private static readonly EMPTY_DOCUMENT: CachedDocumentResult = {
    document: null,
    file_name: null,
    file_size_kb: null,
    updatedAt: null,
  };

  /** Fetches the FFL/SOT PDF (plus the filename/size/timestamp shown in the
   *  preview card), only re-downloading the (large) base64 payload when the
   *  server's `updatedAt` doesn't match what's cached in IndexedDB. */
  private async getCachedCompanyDocument(
    companyId: string,
    documentType: 'ffl' | 'sot',
  ): Promise<CachedDocumentResult> {
    const cacheId = `${companyId}_${documentType}`;
    const cached = await this.localDb.companyDocuments.get(cacheId).catch(() => undefined);

    try {
      const meta = await firstValueFrom(
        this.http.get<{ updatedAt: string }>(
          `${this.apiUrl}/company_profiles/document/${companyId}/${documentType}/meta`,
        ),
      );
      // Only legacy base64 payloads are cacheable. Blob-backed documents come
      // back as a SAS URL that expires within the hour, so a cached copy would
      // hand out a dead link.
      if (cached && cached.updatedAt === meta.updatedAt && cached.document_data?.startsWith('data:')) {
        return {
          document: cached.document_data,
          file_name: cached.file_name ?? null,
          file_size_kb: cached.file_size_kb ?? null,
          updatedAt: cached.updatedAt,
        };
      }

      const res = await firstValueFrom(
        this.http.get<{ document: string; updatedAt: string; file_name?: string; file_size_kb?: number }>(
          `${this.apiUrl}/company_profiles/document/${companyId}/${documentType}`,
        ),
      );
      if (res.document?.startsWith('data:')) {
        await this.localDb.companyDocuments.put({
          id: cacheId,
          company_id: companyId,
          document_type: documentType,
          document_data: res.document,
          updatedAt: res.updatedAt,
          file_name: res.file_name ?? null,
          file_size_kb: res.file_size_kb ?? null,
        });
      }
      return {
        document: res.document,
        file_name: res.file_name ?? null,
        file_size_kb: res.file_size_kb ?? null,
        updatedAt: res.updatedAt,
      };
    } catch (e: any) {
      if (e?.status === 404) {
        await this.localDb.companyDocuments.delete(cacheId).catch(() => undefined);
        return SharedService.EMPTY_DOCUMENT;
      }
      console.warn(`Error fetching ${documentType.toUpperCase()} document:`, e);
      // Offline or request failed — fall back to whatever's cached.
      if (!cached) return SharedService.EMPTY_DOCUMENT;
      return {
        document: cached.document_data ?? null,
        file_name: cached.file_name ?? null,
        file_size_kb: cached.file_size_kb ?? null,
        updatedAt: cached.updatedAt,
      };
    }
  }

  register(registrationData: {
    newUser: User;
    newCompanyProfile: CompanyInfo;
  }): Observable<any> {
    return this.http.post(`${this.apiUrl}/signup`, registrationData);
  }

  //-----------User CRUD Functions MongoDB-----------------
  addUser(user_info: User) {
    this.http
      .post<{ message: string; id: string }>(`${this.apiUrl}/users`, {
        ...user_info,
        company_id: this.company_info.company_id,
      })
      .subscribe({
        next: (response) => {
          user_info.user_id = response.id;
          this.users.push(user_info);
          this.users = [...this.users];
          this.user_added$.next([...this.users]);
          this.raiseSuccessToast(Statements.user_successfully_added);
        },
        error: (error) => {
          console.error('Error:', error);
          this.raiseErrorToast(error);
        },
      });
  }
  updateUser(user_info: User) {
    const userId = user_info.user_id;
    if (!userId) {
      this.raiseErrorToast('User ID is missing - cannot update user');
      return;
    }
    this.http
      .put<{ message: string }>(`${this.apiUrl}/users/${userId}`, user_info)
      .subscribe({
        next: () => {
          this.users = this.users.map((u) =>
            u.user_id === userId ? { ...user_info, user_id: userId } : u,
          );
          this.users = [...this.users];
          this.raiseSuccessToast(Statements.user_successfully_updated);
          this.user_updated$.next([...this.users]);
        },
        error: (error) => {
          console.error('Update user error:', error);
          this.raiseErrorToast(
            error?.error?.message || 'Failed to update user',
          );
        },
      });
  }
  deleteUser(user_to_delete: User) {
    this.http
      .delete(`${this.apiUrl}/users/${user_to_delete.user_id}`)
      .subscribe({
        next: () => {
          this.users = this.users.filter(
            (u) => u.user_id !== user_to_delete.user_id,
          );
          this.users = [...this.users];
          this.user_updated$.next([...this.users]);
          this.raiseSuccessToast(Statements.user_successfully_deleted);
        },
        error: (error) => {
          console.error('Error Deleting User:', error);
          this.raiseErrorToast(Statements.user_failed_to_update);
        },
      });
  }

  //----------- Autofill Form 3310 CRUD Functions MongoDB -----------------
  deleteAutofill() {
    this.http
      .delete<{
        message: string;
      }>(
        `${this.apiUrl}/company_profiles/${this.company_info.company_id}/autofill-form-3310`,
      )
      .subscribe({
        next: (response) => {
          // Clear local copy of autofill data
          this.company_info.autofill_form_3310 = new AutofillForm3310();
          this.raiseSuccessToast('Autofill settings removed');
        },
        error: (error) => {
          console.error('Error Deleting Autofill Form 3310:', error);
          this.raiseErrorToast('Failed to delete autofill');
        },
      });
  }

  // Update (partial) autofill for a company
  updateAutofill(payload: any) {
    this.http
      .put<{
        message: string;
        autofill: any;
      }>(
        `${this.apiUrl}/company_profiles/${this.company_info.company_id}/autofill-form-3310`,
        payload,
      )
      .subscribe({
        next: (res) => {
          if (res && res.autofill) {
            this.company_info.autofill_form_3310 = res.autofill;
          }
          this.raiseSuccessToast('Autofill settings updated');
        },
        error: (err) => {
          console.error('Error updating autofill:', err);
          this.raiseErrorToast('Failed to update autofill');
        },
      });
  }

  async getAllUsers(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.http.get<{ message: string; users: any[] }>(
          `${this.apiUrl}/users`,
        ),
      );
      this.users = response.users.map(
        (entry) =>
          ({
            user_id: entry._id,
            name_first: entry.name_first,
            name_last: entry.name_last,
            username: entry.username,
            role: entry.role,
            position_title: entry.position_title,
            phone: entry.phone,
            email: entry.email,
            signature: entry.signature,
            company_id: entry.company_id,
          }) as User,
      );
      this.users = [...this.users];
      // Cache locally for offline use — clear stale records first so server-deleted users are removed
      await this.localDb.users
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .delete();
      await this.localDb.users.bulkPut(this.users);
    } catch (error) {
      console.warn(
        'Network fetch failed, falling back to IndexedDB for users...',
        error,
      );
      const localUsers = await this.localDb.users
        .where('company_id')
        .equals(this.company_info.company_id || '')
        .toArray();
      this.users = localUsers;
    }
  }

  //---Get Live Inventory data from Vendors MongoDB---
  getVendorData(upc: string): Observable<LiveVendorData> {
    return this.http
      .get<{
        message: string;
        live_inventory: LiveVendorData;
      }>(`${this.apiUrl}/live_inventories/${upc}`)
      .pipe(
        map((response) => {
          if (!response) {
            throw new Error('Vendor data not found');
          }
          let live_inventory: LiveVendorData = new LiveVendorData();
          live_inventory._id = response['_id']?.['$oid'] || response['_id'];
          live_inventory.category = response['category'];
          live_inventory.chattanooga_available_qty =
            response['chattanooga_available_qty'];
          live_inventory.chattanooga_price =
            response['chattanooga_price']?.['$numberDecimal'] ||
            response['chattanooga_price'];
          live_inventory.davidsons_available_qty =
            response['davidsons_available_qty'];
          live_inventory.davidsons_price =
            response['davidsons_price']?.['$numberDecimal'] ||
            response['davidsons_price'];
          live_inventory.lipseys_available_qty =
            response['lipseys_available_qty'];
          live_inventory.lipseys_price =
            response['lipseys_price']?.['$numberDecimal'] ||
            response['lipseys_price'];
          live_inventory.rsr_group_available_qty =
            response['rsr_group_available_qty'];
          live_inventory.rsr_group_price =
            response['rsr_group_price']?.['$numberDecimal'] ||
            response['rsr_group_price'];
          live_inventory.zanders_available_qty =
            response['zanders_available_qty'];
          live_inventory.zanders_price =
            response['zanders_price']?.['$numberDecimal'] ||
            response['zanders_price'];
          live_inventory.allen_arms_available_qty =
            response['allen_arms_available_qty'];
          live_inventory.allen_arms_price =
            response['allen_arms_price']?.['$numberDecimal'] ||
            response['allen_arms_price'];
          live_inventory.desc1 = response['desc1'];
          live_inventory.desc2 = response['desc2'];
          live_inventory.item_number = response['item_number'];
          live_inventory.manufacturer = response['manufacturer'];
          live_inventory.map_price =
            response['map_price']?.['$numberDecimal'] || response['map_price'];
          live_inventory.mfg_part_number = response['mfg_part_number'];
          live_inventory.msrp =
            response['msrp']?.['$numberDecimal'] || response['msrp'];
          live_inventory.upc = response['upc'];
          live_inventory.weight = response['weight'];
          live_inventory.origin = response['origin'];
          live_inventory.imageSource = response['imageSource'];
          live_inventory.attributes = response['attributes'];
          live_inventory.subcategory = response['subcategory'];
          live_inventory.item_type = response['item_type'];
          return live_inventory;
        }),
        catchError((error) => {
          console.error('Error occurred:', error.message);
          this.closeStatusSpinner();
          return throwError(() => error);
        }),
      );
  }
  // New method for searching desc1 or desc2
  getInventoryMatchingSearchTerm(query: string): Observable<LiveVendorData[]> {
    const url = `${
      this.apiUrl
    }/live_inventories/search?query=${encodeURIComponent(query)}`;
    console.log('Requesting URL:', url); // Debug log
    return this.http.get<any[]>(url).pipe(
      map((response) => response.map((item) => this.mapLiveVendorDataItem(item))),
      catchError((error) => {
        console.error('Search error:', error.message);
        this.closeStatusSpinner();
        this.raiseErrorToast('Failed to search items');
        return throwError(() => error);
      }),
    );
  }

  getManufacturersList(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/live_inventories/manufacturers`).pipe(
      catchError((error) => {
        console.error('Error fetching manufacturers:', error.message);
        return of([]);
      }),
    );
  }

  getCategoriesList(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/live_inventories/categories`).pipe(
      catchError((error) => {
        console.error('Error fetching categories:', error.message);
        return of([]);
      }),
    );
  }

  private mapLiveInventoryItem(item: any): LiveVendorData {
    let live_inventory: LiveVendorData = new LiveVendorData();
    live_inventory._id = item['_id']?.['$oid'] || item['_id'];
    live_inventory.category = item['category'];
    live_inventory.chattanooga_available_qty = item['chattanooga_available_qty'];
    live_inventory.chattanooga_price =
      item['chattanooga_price']?.['$numberDecimal'] || item['chattanooga_price'];
    live_inventory.davidsons_available_qty = item['davidsons_available_qty'];
    live_inventory.davidsons_price =
      item['davidsons_price']?.['$numberDecimal'] || item['davidsons_price'];
    live_inventory.lipseys_available_qty = item['lipseys_available_qty'];
    live_inventory.lipseys_price =
      item['lipseys_price']?.['$numberDecimal'] || item['lipseys_price'];
    live_inventory.rsr_group_available_qty = item['rsr_group_available_qty'];
    live_inventory.rsr_group_price =
      item['rsr_group_price']?.['$numberDecimal'] || item['rsr_group_price'];
    live_inventory.zanders_available_qty = item['zanders_available_qty'];
    live_inventory.zanders_price =
      item['zanders_price']?.['$numberDecimal'] || item['zanders_price'];
    live_inventory.allen_arms_available_qty = item['allen_arms_available_qty'];
    live_inventory.allen_arms_price =
      item['allen_arms_price']?.['$numberDecimal'] || item['allen_arms_price'];
    live_inventory.desc1 = item['desc1'];
    live_inventory.desc2 = item['desc2'];
    live_inventory.item_number = item['item_number'];
    live_inventory.manufacturer = item['manufacturer'];
    live_inventory.map_price = item['map_price']?.['$numberDecimal'] || item['map_price'];
    live_inventory.mfg_part_number = item['mfg_part_number'];
    live_inventory.msrp = item['msrp']?.['$numberDecimal'] || item['msrp'];
    live_inventory.upc = item['upc'];
    live_inventory.weight = item['weight'];
    live_inventory.origin = item['origin'];
    live_inventory.imageSource = item['imageSource'];
    live_inventory.subcategory = item['subcategory'];
    live_inventory.item_type = item['item_type'];
    live_inventory.attributes = item['attributes'];
    return live_inventory;
  }

  searchInventoryAdvanced(filters: {
    manufacturer?: string;
    category?: string;
  }): Observable<LiveVendorData[]> {
    return this.http
      .post<any[]>(`${this.apiUrl}/live_inventories/search-advanced`, filters)
      .pipe(
        map((response) => response.map((item) => this.mapLiveInventoryItem(item))),
        catchError((error) => {
          console.error('Advanced search error:', error.message);
          this.raiseErrorToast('Failed to load items.');
          return of([]);
        }),
      );
  }

  getLiveInventoryItemByUpc(upc: string): Observable<LiveVendorData | null> {
    return this.http.get<any>(`${this.apiUrl}/live_inventories/${upc}`).pipe(
      map((response) => {
        if (!response) return null;
        const item = new LiveVendorData();
        item.upc = response['upc'];
        item.item_number = response['item_number'];
        item.manufacturer = response['manufacturer'];
        item.mfg_part_number = response['mfg_part_number'];
        item.origin = response['origin'];
        item.imageSource = response['imageSource'];
        return item;
      }),
      catchError(() => of(null)),
    );
  }

  // Grid rows re-render the same UPC repeatedly while scrolling (AG Grid
  // recycles cell renderer instances), so cache the in-flight/completed
  // request per identifier set rather than re-hitting the API each time.
  private thumbnailUrlCache = new Map<string, Observable<{ thumbnailUrls: string[] }>>();

  // A virtualized grid page asks for every visible row at once, so each lookup is
  // parked here and flushed as one batched request rather than one call per row
  // (which would also exhaust the browser's ~6 connections per host).
  private pendingThumbnailLookups: {
    cacheKey: string;
    item: Record<string, string | undefined>;
    subject: ReplaySubject<{ thumbnailUrls: string[] }>;
  }[] = [];
  private thumbnailFlushTimer: ReturnType<typeof setTimeout> | null = null;
  private static readonly THUMBNAIL_BATCH_LIMIT = 200;

  getInventoryThumbnailUrl(
    upc: string,
    itemNumber?: string,
    manufacturer?: string,
    mfgPartNumber?: string,
    origin?: string,
    imageSource?: string,
  ): Observable<{ thumbnailUrls: string[] }> {
    const cacheKey = [upc, itemNumber, manufacturer, mfgPartNumber, origin, imageSource]
      .map((v) => v ?? '')
      .join('|');
    const cached = this.thumbnailUrlCache.get(cacheKey);
    if (cached) return cached;

    const subject = new ReplaySubject<{ thumbnailUrls: string[] }>(1);
    const shared$ = subject.asObservable();
    this.thumbnailUrlCache.set(cacheKey, shared$);
    this.pendingThumbnailLookups.push({
      cacheKey,
      item: { key: cacheKey, upc, itemNumber, mfgPartNumber, imageSource },
      subject,
    });

    if (!this.thumbnailFlushTimer) {
      this.thumbnailFlushTimer = setTimeout(() => this.flushThumbnailLookups(), 50);
    }
    return shared$;
  }

  private flushThumbnailLookups(): void {
    this.thumbnailFlushTimer = null;
    const pending = this.pendingThumbnailLookups;
    this.pendingThumbnailLookups = [];
    if (!pending.length) return;

    for (let i = 0; i < pending.length; i += SharedService.THUMBNAIL_BATCH_LIMIT) {
      const chunk = pending.slice(i, i + SharedService.THUMBNAIL_BATCH_LIMIT);
      this.http
        .post<{ thumbnailUrlsByKey: Record<string, string[]> }>(
          `${this.apiUrl}/inventory_thumbnails/batch`,
          { items: chunk.map((entry) => entry.item) },
        )
        .subscribe({
          next: (response) => {
            for (const entry of chunk) {
              entry.subject.next({
                thumbnailUrls: response?.thumbnailUrlsByKey?.[entry.cacheKey] || [],
              });
              entry.subject.complete();
            }
          },
          error: () => {
            // Drop the cache entries so scrolling past these rows again retries
            // rather than staying blank on a one-off failure.
            for (const entry of chunk) {
              this.thumbnailUrlCache.delete(entry.cacheKey);
              entry.subject.next({ thumbnailUrls: [] });
              entry.subject.complete();
            }
          },
        });
    }
  }

  // Populated from GET /api/favorites and kept in sync by add/removeFavorite.
  // The grid's favorite stars share this single request rather than each row
  // hitting the API independently.
  private favoritedUpcs = new Set<string>();
  private favoritesRequest$: Observable<string[]> | null = null;

  loadFavoriteUpcs(): Observable<string[]> {
    if (this.favoritesRequest$) return this.favoritesRequest$;

    this.favoritesRequest$ = this.http
      .get<{ data: { upc: string }[] }>(`${this.apiUrl}/favorites`)
      .pipe(
        map((res) => (res?.data || []).map((f) => f.upc)),
        tap((upcs) => (this.favoritedUpcs = new Set(upcs))),
        catchError(() => {
          this.favoritesRequest$ = null;
          return of([]);
        }),
        shareReplay(1),
      );
    return this.favoritesRequest$;
  }

  isFavorite(upc: string): boolean {
    return this.favoritedUpcs.has(upc);
  }

  addFavorite(item: {
    upc: string;
    item_number?: string;
    manufacturer?: string;
    description?: string;
    mfg_part_number?: string;
  }): Observable<unknown> {
    return this.http.post(`${this.apiUrl}/favorites`, item).pipe(
      tap(() => this.favoritedUpcs.add(item.upc)),
    );
  }

  removeFavorite(upc: string): Observable<unknown> {
    return this.http.delete(`${this.apiUrl}/favorites/${encodeURIComponent(upc)}`).pipe(
      tap(() => this.favoritedUpcs.delete(upc)),
    );
  }

  // Raw Mongo documents sometimes carry Extended JSON wrappers (`$numberDecimal`,
  // `$oid`) depending on which code path produced them, so every read of
  // live_inventories unwraps through here rather than trusting the field is a
  // plain string/number already.
  private mapLiveVendorDataItem(item: any): LiveVendorData {
    const live_inventory: LiveVendorData = new LiveVendorData();
    live_inventory._id = item['_id']?.['$oid'] || item['_id'];
    live_inventory.category = item['category'];
    live_inventory.chattanooga_available_qty = item['chattanooga_available_qty'];
    live_inventory.chattanooga_price =
      item['chattanooga_price']?.['$numberDecimal'] || item['chattanooga_price'];
    live_inventory.davidsons_available_qty = item['davidsons_available_qty'];
    live_inventory.davidsons_price =
      item['davidsons_price']?.['$numberDecimal'] || item['davidsons_price'];
    live_inventory.lipseys_available_qty = item['lipseys_available_qty'];
    live_inventory.lipseys_price =
      item['lipseys_price']?.['$numberDecimal'] || item['lipseys_price'];
    live_inventory.rsr_group_available_qty = item['rsr_group_available_qty'];
    live_inventory.rsr_group_price =
      item['rsr_group_price']?.['$numberDecimal'] || item['rsr_group_price'];
    live_inventory.zanders_available_qty = item['zanders_available_qty'];
    live_inventory.zanders_price =
      item['zanders_price']?.['$numberDecimal'] || item['zanders_price'];
    live_inventory.allen_arms_available_qty = item['allen_arms_available_qty'];
    live_inventory.allen_arms_price =
      item['allen_arms_price']?.['$numberDecimal'] || item['allen_arms_price'];
    live_inventory.desc1 = item['desc1'];
    live_inventory.desc2 = item['desc2'];
    live_inventory.item_number = item['item_number'];
    live_inventory.manufacturer = item['manufacturer'];
    live_inventory.map_price = item['map_price']?.['$numberDecimal'] || item['map_price'];
    live_inventory.mfg_part_number = item['mfg_part_number'];
    live_inventory.msrp = item['msrp']?.['$numberDecimal'] || item['msrp'];
    live_inventory.upc = item['upc'];
    live_inventory.weight = item['weight'];
    live_inventory.origin = item['origin'];
    live_inventory.imageSource = item['imageSource'];
    live_inventory.attributes = item['attributes'];
    live_inventory.subcategory = item['subcategory'];
    live_inventory.item_type = item['item_type'];
    return live_inventory;
  }

  getAllLiveInventoryData(): Observable<LiveVendorData[]> {
    return this.http
      .get<{
        message: string;
        live_inventories: LiveVendorData[];
      }>(`${this.apiUrl}/live_inventories`)
      .pipe(
        map((response) => response.live_inventories.map((item) => this.mapLiveVendorDataItem(item))),
        catchError((error) => {
          console.error('Error occurred:', error.message);
          this.closeStatusSpinner();
          this.raiseErrorToast('Failed to retrieve live inventory data');
          return throwError(() => error);
        }),
      );
  }

  // Items a company has favorited, pulled from favorite_inventory_items (Cosmos)
  // and joined against live_inventories (Atlas) for full grid display data.
  getFavoriteInventoryItems(): Observable<LiveVendorData[]> {
    return this.http
      .get<{ data: { upc: string }[] }>(`${this.apiUrl}/favorites`)
      .pipe(
        switchMap((res) => {
          const upcs = (res?.data || []).map((f) => f.upc);
          if (!upcs.length) return of([]);

          return this.http
            .post<any[]>(`${this.apiUrl}/live_inventories/by-upcs`, { upcs })
            .pipe(map((items) => items.map((item) => this.mapLiveVendorDataItem(item))));
        }),
        catchError((error) => {
          console.error('Error occurred:', error.message);
          this.raiseErrorToast('Failed to retrieve favorite items');
          return throwError(() => error);
        }),
      );
  }
  getAllDistinctCategories(): Observable<string[]> {
    return this.http
      .get<any[]>(`${this.apiUrl}/live_inventories/categories-with-count`)
      .pipe(
        map((response) => response),
        catchError((error) => {
          console.error('Error occurred:', error.message);
          return throwError(() => error);
        }),
      );
  }
  getVendorInventoryBySelectedCategory(selected_categories: string[]) {
    return this.http.post<LiveVendorData[]>(
      `${this.apiUrl}/live_inventories/filter-by-categories`,
      { selected_categories },
    );
  }

  //---Get Current ATF FFL List MongoDB---
  verifyFflAtfList(ffl: string): Observable<{ message: string; ffl: AtfFfl }> {
    return this.http.get<{ message: string; ffl: AtfFfl }>(
      `${this.apiUrl}/atf_ffl_lists/lookup/${ffl}`,
    );
    // .pipe(
    //   map((response) => {
    //     return response.atf_ffl_list.map((entry) => {
    //       return {
    //         id: entry._id,
    //         ffl: entry.ffl_number,
    //         legal_name: entry.license_name,
    //         business_name: entry.business_name,
    //         premise_street: entry.premise_street,
    //         premise_city: entry.premise_city,
    //         premise_state: entry.premise_state,
    //         premise_zip_code: entry.premise_zip_code,
    //         phone_number: entry.voice_telephone,
    //         issue_date: entry.loa_issue_date,
    //         expiration_date: entry.loa_expiration_date,
    //       } as FFL;
    //     });
    //   }),
    //   catchError((error) => {
    //     console.error('Error fetching ATF FFL list', error);
    //     return throwError(() => error);
    //   })
    // );
  }

  //-----------------Toast functions-----------------
  raiseSuccessToast(message: string, title?: string) {
    const toast_title = title ? title : 'Success';
    this.toast.success(message, toast_title);
  }
  raiseWarningToast(message: string, title?: string) {
    const toast_title = title ? title : 'Warning';
    this.toast.warning(message, toast_title);
  }
  raiseErrorToast(message: string, title?: string) {
    const toast_title = title ? title : 'Error';
    this.toast.error(message, toast_title);
  }
  raiseInfoToast(message: string, title?: string) {
    const toast_title = title ? title : 'Info';
    this.toast.info(message, toast_title);
  }

  //----------------Modal functions---------------------
  closeModal(modalId: number) {
    this.modalService.hide(modalId);
  }
  /** Close every modal currently open. Called by the inactivity sign-out so
   * the user doesn't return to the login page with a stale modal on top.
   * Loops because ngx-bootstrap's hide() without an id closes only the
   * most recent; a safety counter prevents an accidental infinite loop. */
  closeAllModals(): void {
    let safety = 20;
    while (this.modalService.getModalsCount() > 0 && safety-- > 0) {
      this.modalService.hide();
    }
  }

  /** Cleanup shared by both the inactivity-driven sign-out and the explicit
   * Log Out button: close any open modal so it doesn't outlive the session,
   * and reset the in-memory user so background polling stops immediately.
   * Also clears cached offline login credentials for security. */
  signOutCleanup(): void {
    // Clear cached offline credentials so a logged-out device can't re-enter offline
    const email = (this.logged_in_user as any)?.email;
    if (email) {
      this.localDb.cachedCredentials.delete(email.toLowerCase()).catch((e: any) =>
        console.warn('Failed to clear cached credentials on logout:', e)
      );
    }
    this.closeAllModals();
    this.logged_in_user = new User();
  }
  openMessageModal(message: string, error?: boolean) {
    this.modalOptions = {
      id: ModalID.message,
      initialState: {
        message: message,
        error: error,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      MessageComponent,
      Object.assign({ id: ModalID.status }, this.modalOptions),
    );
  }
  openYesNoModal(
    question: string,
    optional_details?: {},
    reverse_buttons?: boolean,
  ) {
    this.modalOptions = {
      initialState: {
        question: question,
        optional_details: optional_details ? optional_details : {},
        reverse_btn_color: reverse_buttons ? reverse_buttons : false,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      YesNoComponent,
      Object.assign({ id: ModalID.yes_no }, this.modalOptions),
    );
  }
  openTextModal(header: string) {
    this.modalOptions = {
      initialState: {
        header: header,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      TextModalComponent,
      Object.assign({ id: ModalID.text_modal }, this.modalOptions),
    );
  }
  openFirearmInfoDash(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.firearm_info_dash,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    this.modalRef = this.modalService.show(
      FirearmInfoDashComponent,
      Object.assign({ id: ModalID.firearm_info_dash }, this.modalOptions),
    );
  }
  openEditBoundBookFirearm(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.edit_bb_firearm,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    this.modalRef = this.modalService.show(
      EditBbFirearmComponent,
      Object.assign({ id: ModalID.edit_bb_firearm }, this.modalOptions),
    );
  }
  openEditBoundBookAcquisition(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.edit_bb_acquisition,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      EditBbAcquisitionComponent,
      Object.assign({ id: ModalID.edit_bb_acquisition }, this.modalOptions),
    );
  }
  openEditBoundBookDisposition(bound_book_entry: BoundBookEntry) {
    this.modalOptions = {
      id: ModalID.edit_bb_disposition,
      initialState: {
        bound_book_entry: bound_book_entry,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      EditBbDispositionComponent,
      Object.assign({ id: ModalID.edit_bb_disposition }, this.modalOptions),
    );
  }
  openQuestionnaireIntro() {
    this.modalOptions = {
      id: ModalID.questionnaire_intro,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    this.modalRef = this.modalService.show(
      QuestionnaireIntoComponent,
      Object.assign({ id: ModalID.questionnaire_intro }, this.modalOptions),
    );
  }
  openDigitalSignature(signature_type: string) {
    this.modalOptions = {
      id: ModalID.digital_signature,
      initialState: {
        signature_type: signature_type,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      DigitalSignatureComponent,
      Object.assign({ id: ModalID.digital_signature }, this.modalOptions),
    );
  }
  openKioskSelection() {
    this.modalOptions = {
      id: ModalID.kiosk_selection,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      KioskSelectionComponent,
      Object.assign({ id: ModalID.kiosk_selection }, this.modalOptions),
    );
  }
  openAddEditUser(modal_type: string, selected_user?: User) {
    this.modalOptions = {
      id: ModalID.add_edit_users,
      initialState: {
        selected_user: selected_user,
        modal_type: modal_type,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      AddEditUsersComponent,
      Object.assign({ id: ModalID.add_edit_users }, this.modalOptions),
    );
  }
  openCreateProductService(
    modal_type: string,
    item: ProductServiceItem,
    rowIndex?: number,
    component?: string,
  ) {
    this.modalOptions = {
      id: ModalID.add_edit_product_service,
      initialState: {
        modal_type: modal_type,
        item: item,
        row_index: rowIndex,
        calling_component: component,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    console.warn(this.modalOptions);
    this.modalRef = this.modalService.show(
      CreateProductServiceComponent,
      Object.assign(
        { id: ModalID.add_edit_product_service },
        this.modalOptions,
      ),
    );
  }
  openChoiceModal(question: string, optional_details: {}, options: string[]) {
    this.modalOptions = {
      id: ModalID.choice,
      initialState: {
        question: question,
        options: options,
        optional_details: optional_details,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      ChoiceComponent,
      Object.assign({ id: ModalID.choice }, this.modalOptions),
    );
  }
  openAddEditContactModal(
    modal_type: string,
    contact_type: string,
    contact?: any,
    rowIndex?: number,
  ) {
    this.modalOptions = {
      id: ModalID.add_edit_contact,
      initialState: {
        modal_type: modal_type,
        customer: contact as Customer,
        vendor: contact as Vendor,
        rowIndex: rowIndex,
        contact_type: contact_type,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-custom-width',
    };
    this.modalRef = this.modalService.show(
      AddEditContactComponent,
      Object.assign({ id: ModalID.add_edit_contact }, this.modalOptions),
    );
  }
  openSalesReceiptPrintModal(sales_receipt: SalesReceipt) {
    this.modalOptions = {
      id: ModalID.sales_receipt_print,
      initialState: {
        sales_receipt: sales_receipt,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-custom-width',
    };
    this.modalRef = this.modalService.show(
      SalesReceiptPrintComponent,
      Object.assign({ id: ModalID.sales_receipt_print }, this.modalOptions),
    );
  }
  openPackingSlipPrintModal(disposition_items: BoundBookEntry[]) {
    this.modalOptions = {
      id: ModalID.ffl_packing_slip_print,
      initialState: {
        disposition_items: disposition_items,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-custom-width',
    };
    this.modalRef = this.modalService.show(
      FflPackingSlipPrintComponent,
      Object.assign({ id: ModalID.ffl_packing_slip_print }, this.modalOptions),
    );
  }
  openSerialNumberModal(
    item_count: number,
    saleItem: SalesItem,
    rowIndex?: number,
  ) {
    this.modalOptions = {
      id: ModalID.firearm_serial_number_list,
      initialState: {
        item_count: item_count,
        saleItem: saleItem,
        rowIndex: rowIndex,
      } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      SerialNumberListComponent,
      Object.assign({ id: ModalID.sales_receipt_print }, this.modalOptions),
    );
    console.log('opening the serial number list modal');
  }
  openScanIdModal() {
    this.modalOptions = {
      id: ModalID.scan_id,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      ScanIdComponent,
      Object.assign({ id: ModalID.scan_id }, this.modalOptions),
    );
    console.log('opening the scan ID modal1');
  }
  openInventoryOptionsModal(
    type?: string,
    modal_type?: string,
    row_data?: any,
    item_data?: { upc?: string; name?: string; description?: string },
  ) {
    this.modalOptions = {
      id: ModalID.inventory_options,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
    };
    if (type === 'auto_purchase') {
      this.modalOptions.initialState = {
        modal_type: modal_type,
        auto_purchase_selected_row: row_data,
        request_type: type,
        prefill_item_data: item_data,
      } as any;
    } else {
      this.modalOptions.initialState = {
        modal_type: modal_type,
        alert_selected_row: row_data,
        request_type: type,
        prefill_item_data: item_data,
      } as any;
    }
    this.modalRef = this.modalService.show(
      InventoryOptionsComponent,
      Object.assign({ id: ModalID.inventory_options }, this.modalOptions),
    );
  }

  openOptimizerItemModal(modal_type?: string, row_data?: any) {
    this.modalOptions = {
      id: ModalID.optimizer_item,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl',
      initialState: {
        modal_type: modal_type,
        optimizer_selected_row: row_data,
      } as any,
    };
    this.modalRef = this.modalService.show(
      OptimizerItemComponent,
      Object.assign({ id: ModalID.optimizer_item }, this.modalOptions),
    );
  }

  openInventorySearchModal() {
    this.modalOptions = {
      id: 99,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-xl custom-modal-90',
    };
    this.modalRef = this.modalService.show(
      InventorySearchComponent,
      Object.assign({ id: 99 }, this.modalOptions),
    );
  }
  openImportVendorInventoryModal() {
    this.modalOptions = {
      id: ModalID.import_vendor_inventory,
      // initialState: {
      //   categories: categories,
      // } as any,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      ImportByCategoryComponent,
      Object.assign({ id: ModalID.import_vendor_inventory }, this.modalOptions),
    );
  }
  openFflSearchModal() {
    const modalOptions: ModalOptions = {
      id: ModalID.ffl_search,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-ffl-search',
    };
    this.modalRef = this.modalService.show(
      FflSearchComponent,
      Object.assign({ id: ModalID.ffl_search }, modalOptions),
    );
  }
  openDispoBuildModal(component: string) {
    this.dispo_build_modal_shown = true;
    const modalOptions: ModalOptions = {
      initialState: {
        selected_component: component,
      },
      id: ModalID.dispo_build,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-ffl-search',
    };
    this.modalRef = this.modalService.show(
      DispoBuildComponent,
      Object.assign({ id: ModalID.dispo_build }, modalOptions),
    );
  }
  addEditFirearmClick(
    modal_type: string,
    row_data?: Firearm,
    rowIndex?: number,
    component?: string,
  ) {
    const modalOptions: ModalOptions = {
      initialState: {
        modal_type: modal_type,
        selected_row:
          modal_type === ModalType.edit || row_data.firearm_upc
            ? row_data
            : null,
        row_index: rowIndex,
        calling_component: component,
      } as any,
      ignoreBackdropClick: true,
      // backdrop: 'static',
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered, modal-lg',
    };
    console.warn(modalOptions);
    this.modalRef = this.modalService.show(
      FirearmManagementEditComponent,
      Object.assign({ id: ModalID.firearm_management_edit }, modalOptions),
    );
  }
  openUserCredentials(ok_button_label: string, cancel_button_label: string) {
    const modalOptions: ModalOptions = {
      id: ModalID.user_credentials,
      ignoreBackdropClick: true,
      initialState: {
        ok_button: ok_button_label,
        cancel_button: cancel_button_label,
      },
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered ',
    };
    this.modalRef = this.modalService.show(
      UserCredentialsComponent,
      Object.assign({ id: ModalID.user_credentials }, modalOptions),
    );
  }
  openIdSelectionModal() {
    const modalOptions: ModalOptions = {
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-id-selection',
    };
    this.modalRef = this.modalService.show(
      DriversLicenseSelectionComponent,
      Object.assign({ id: ModalID.drivers_license_selection }, modalOptions),
    );
  }
  openDuplicateTTSNSelectionModal(id: string) {
    const modalOptions: ModalOptions = {
      initialState: {
        form4473Id: id,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-duplicate-ttsn',
    };
    this.modalRef = this.modalService.show(
      DuplicateTtsnComponent,
      Object.assign({ id: ModalID.duplicate_ttsn }, modalOptions),
    );
  }
  openCompetitorPricingModal(
    pricing_data: CompetitorPricing[],
    distributor_price: string,
  ) {
    //
    const modalOptions: ModalOptions = {
      initialState: {
        pricing_data: pricing_data,
        distributor_price: +distributor_price,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-competitor-pricing',
    };
    this.modalRef = this.modalService.show(
      CompetitorPricingComponent,
      Object.assign({ id: ModalID.competitor_pricing }, modalOptions),
    );
  }
  openEnterIdModal(minimum_are_requirement: number) {
    const modalOptions: ModalOptions = {
      initialState: {
        minimum_are_requirement: minimum_are_requirement,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      EnterIdComponent,
      Object.assign({ id: ModalID.enter_id }, modalOptions),
    );
  }
  openCreateForm3310Modal() {
    const modalOptions: ModalOptions = {
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      CreateForm3310Component,
      Object.assign({ id: ModalID.create_form_3310 }, modalOptions),
    );
  }

  openInventoryAlertsModal() {
    const modalOptions: ModalOptions = {
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog modal-dialog-centered modal-lg',
    };
    this.modalRef = this.modalService.show(
      InventoryAlertsComponent,
      Object.assign({ id: ModalID.inventory_alerts }, modalOptions),
    );
  }
  openAddEditFFLModal(modal_type: string, row_data?: FFL) {
    const modalOptions: ModalOptions = {
      initialState: {
        modal_type: modal_type,
        selected_row: modal_type === ModalType.edit ? row_data : null,
      } as any,
      ignoreBackdropClick: true,
      // backdrop: 'static',
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered, modal-lg',
    };
    this.modalRef = this.modalService.show(
      FflManagementEditComponent,
      Object.assign({ id: ModalID.firearm_management_edit }, modalOptions),
    );
  }
  openEmailModal(
    email_type: string,
    default_email_values?: Email,
    initialAttachments?: {
      name: string;
      content: string;
      contentType: string;
    }[],
    form4473_id?: string,
    pending3310_id?: string,
  ) {
    const modalOptions: ModalOptions = {
      initialState: {
        default_email_values: default_email_values,
        email_type: email_type,
        initialAttachments: initialAttachments || [],
        form4473_id: form4473_id,
        pending3310_id: pending3310_id,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered modal-xl',
    };
    this.modalRef = this.modalService.show(
      EmailComponent,
      Object.assign({ id: ModalID.email }, modalOptions),
    );
  }
  openNewBoundBookModal() {
    const modalOptions: ModalOptions = {
      // initialState: {

      // },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      AddBoundBookComponent,
      Object.assign({ id: ModalID.add_bound_book }, modalOptions),
    );
  }
  openEditBoundBookModal(book: any) {
    const modalOptions: ModalOptions = {
      initialState: {
        isEdit: true,
        bookToEdit: book,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      AddBoundBookComponent,
      Object.assign({ id: ModalID.add_bound_book }, modalOptions),
    );
  }
  openBoundBookPrintModal(bound_book_entries: any[]) {
    const modalOptions: ModalOptions = {
      initialState: {
        bound_book_entries: bound_book_entries,
      },
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-fullscreen modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(
      BoundBookPrintComponent,
      Object.assign({ id: ModalID.bound_book_print }, modalOptions),
    );
  }

  changeRoute(page: string) {
    this.router.navigate([page]);
  }

  editUser(user_info: User) {
    // create a api call to edit a user
    console.log('create a api call to edit a user');
  }

  createNewCompanyCollection() {
    // this.http
    //   .post<{ message: string; firearmId: string }>(
    //     `${this.apiUrl}/firearms`,
    //     firearm_entry
    //   )
    //   .subscribe({
    //     next: (response) => {
    //       firearm_entry.id = response.firearmId;
    //       this.firearm_list.push(firearm_entry);
    //       this.firearm_list_updated$.next([...this.firearm_list]);
    //     },
    //     error: (error) => {
    //       console.error('Error:', error);
    //       this.raiseErrorToast(error);
    //     },
    //   });
  }
  // getCustomerInfo(selected_customer_id: string): Customer {
  //   let customer_info: Customer = this.accountingService.customers.filter(
  //     (customer) => customer.id === selected_customer_id
  //   )[0];
  //   return customer_info;
  // }
  findUserAccountDetails(user_id: string) {
    this.loggedInUser = this.master.company.users.filter(
      (user) => user.user_id === user_id,
    )[0];
    this.logged_in_user = this.master.company.users.filter(
      (user) => user.user_id === user_id,
    )[0];
  }

  get4473Pdf() {
    return this.http
      .get<{
        message: string;
        live_inventory: LiveVendorData;
      }>(`http://localhost:3000/api/pdf`)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          console.error('Error occurred:', error.message);
          this.closeStatusSpinner();
          this.raiseErrorToast('Failed to retrieve vendor data');
          return throwError(() => error);
        }),
      );
  }

  createAutoPurchase(AutoPurchase: AutoPurchase) {
    console.warn(AutoPurchase);
    this.raiseWarningToast('Im creating a auto purchase record');
  }
  createInventoryAlert(InventoryAlert: InventoryAlert) {
    console.warn(InventoryAlert);
    this.raiseWarningToast('Im creating a inventory alert record');
  }
  updateAutoPurchase(AutoPurchase: AutoPurchase) {
    console.warn(AutoPurchase);
    this.raiseWarningToast('Im updating a auto purchase record');
  }
  updateInventoryAlert(InventoryAlert: InventoryAlert) {
    console.warn(InventoryAlert);
    this.raiseWarningToast('Im updating a inventory alert record');
  }
  openFilePicker(file_format: string) {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
    fileInput.onchange = (event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files ? target.files[0] : null;
      if (file) {
        const file_info: FileInfo = new FileInfo();
        file_info.file = file;
        file_info.file_format = file_format;
        this.file_selected_from_picker$.next(file_info);
      }
    };
  }
  validateCSVColumns(
    file: File,
    expected_columns: string[],
    import_type: string,
  ) {
    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const actual_columns = results.meta.fields;
        const missingColumns = expected_columns.filter(
          (col) => !actual_columns.includes(col),
        );
        const extraColumns = actual_columns.filter(
          (col) => !expected_columns.includes(col),
        );

        if (missingColumns.length > 0) {
          this.openMessageModal(
            `Missing columns: ${missingColumns.join(', ')}`,
          );
        } else if (extraColumns.length > 0) {
          this.openMessageModal(`Extra columns: ${extraColumns.join(', ')}`);
        } else {
          this.file_verified$.next({ file, import_type });
        }
      },
      error: (error) => {
        console.error('Error parsing CSV file:', error);
      },
    });
  }
  validateXlsxColumns(
    file: File,
    expected_columns: string[],
    import_type: string,
  ) {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const buffer = event.target?.result as ArrayBuffer;
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.worksheets[0];
      const actualColumns: string[] = [];
      worksheet.getRow(1).eachCell((cell) => {
        actualColumns.push(String(cell.value ?? ''));
      });
      const missingColumns = expected_columns.filter(
        (col) => !actualColumns.includes(col),
      );
      const extraColumns = actualColumns.filter(
        (col) => !expected_columns.includes(col),
      );
      if (missingColumns.length > 0) {
        this.openMessageModal(`Missing columns: ${missingColumns.join(', ')}`);
      } else if (extraColumns.length > 0) {
        this.openMessageModal(`Extra columns: ${extraColumns.join(', ')}`);
      } else {
        this.file_verified$.next({ file, import_type });
      }
    };
    reader.readAsArrayBuffer(file);
  }

  competitor_pricing_retrieved$: Subject<any> = new Subject();

  getCompetitorPricing(query: string): Observable<CompetitorPricing[] | null> {
    const url = `${this.apiUrl}/competitor_pricing?query=${encodeURIComponent(
      query,
    )}`;
    return this.http
      .get<CompetitorPricing[] | null>(url, {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      })
      .pipe(
        map((response: any) => {
          // Validate and transform response if needed
          if (response && 'price' in response[0]) {
            this.competitor_pricing_retrieved$.next(response);
            return response as CompetitorPricing[];
          }
          return null; // Return null if response doesn’t match CompetitorPricing
        }),
        catchError((error) => {
          console.error('Error fetching competitor pricing:', error);
          this.raiseErrorToast('Failed to retrieve competitor pricing');
          return throwError(() => error);
        }),
      );
  }

  async getCompetitorPricingAsync(
    query: string,
  ): Promise<CompetitorPricing[] | null> {
    try {
      const response = await firstValueFrom(this.getCompetitorPricing(query));
      return response;
    } catch (error) {
      console.error('Error in getCompetitorPricingAsync:', error);
      throw error; // Re-throw to allow caller to handle
    }
  }
  openExternalLink(url: string) {
    window.open(url, '_blank');
  }
  async generateAndDisplay4473(form4473: Form4473) {
    console.warn(form4473);
    let rawBlobUrl = '';

    try {
      console.log('Starting PDF generation');
      this.openStatusSpinner('Generating PDF');

      // Get the PDF as a blob
      const pdfBlob = await firstValueFrom(
        this.http.post(`${this.apiUrl}/generate_4473/generate`, form4473, {
          responseType: 'blob',
        }),
      );

      console.log('PDF received. Size:', pdfBlob.size, 'Type:', pdfBlob.type);

      this.closeStatusSpinner();

      // Verify we got a valid PDF
      if (!pdfBlob || pdfBlob.size === 0) {
        throw new Error('Received empty PDF');
      }

      // Ensure correct MIME type
      const pdfBlobTyped = new Blob([pdfBlob], { type: 'application/pdf' });
      rawBlobUrl = URL.createObjectURL(pdfBlobTyped);

      console.log('Blob URL created:', rawBlobUrl);

      // Display PDF
      this.displayPdfInOverlay(rawBlobUrl, form4473);

      // this.raiseSuccessToast('PDF generated successfully');
    } catch (error: any) {
      console.error('PDF generation error:', error);
      this.closeStatusSpinner();
      this.raiseErrorToast('Failed to generate PDF. Please try again.');
      if (rawBlobUrl) URL.revokeObjectURL(rawBlobUrl);
    }
  }

  async generate3310AndOpenEmailModal(
    form4473: Form4473,
    pending3310_id?: string,
  ) {
    try {
      this.openStatusSpinner('Generating Form 3310.4');

      const pdfBlob = await firstValueFrom(
        this.http.post(
          `${this.apiUrl}/generate_3310/generate`,
          { form4473_id: form4473._id },
          { responseType: 'blob' },
        ),
      );

      this.closeStatusSpinner();

      if (!pdfBlob || pdfBlob.size === 0)
        throw new Error('Received empty Form 3310.4 PDF');

      // Convert blob → base64 so the email modal can attach it
      const base64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve((reader.result as string).split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(pdfBlob);
      });

      const autofill = this.company_info?.autofill_form_3310 || ({} as any);
      const template =
        (this.company_info?.email_templates as any)?.['form_3310'] || {};

      const DEV_EMAIL = 'khaos.software.solutions@gmail.com';
      const isDev = !environment.production;
      const toAddresses = isDev
        ? DEV_EMAIL
        : [autofill.agency_email, autofill.atf_email]
            .filter(Boolean)
            .join(', ');

      const defaultEmail = new Email();
      defaultEmail.to = toAddresses;
      defaultEmail.subject = template.subject || '';
      defaultEmail.body = template.body || '';

      this.openEmailModal(
        EmailType.form_3310,
        defaultEmail,
        [
          {
            name: `Form-3310_${form4473.transaction_serial_number || 'draft'}.pdf`,
            content: base64,
            contentType: 'application/pdf',
          },
        ],
        form4473._id,
        pending3310_id,
      );
    } catch (error: any) {
      console.error('Form 3310.4 generation error:', error);
      this.closeStatusSpinner();
      this.raiseErrorToast('Failed to generate Form 3310.4. Please try again.');
    }
  }

  async getPending3310Records(): Promise<void> {
    try {
      const records = await firstValueFrom(
        this.http.get<any[]>(`${this.apiUrl}/pending_form_3310s`),
      );
      this.pending_3310_records = records || [];
    } catch (error: any) {
      console.error('Failed to fetch pending 3310 records:', error);
      this.pending_3310_records = [];
    }
  }

  async createPending3310Record(form4473: Form4473): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post(`${this.apiUrl}/pending_form_3310s`, {
          form4473_id: form4473._id,
          transaction_serial_number: form4473.transaction_serial_number || null,
          form4473_created_at: form4473.createdAt || new Date().toISOString(),
        }),
      );
      await this.getPending3310Records();
    } catch (error: any) {
      console.error('Failed to create pending 3310 record:', error);
    }
  }

  async deletePending3310AndMarkSent(pending3310_id: string): Promise<void> {
    try {
      await firstValueFrom(
        this.http.delete(`${this.apiUrl}/pending_form_3310s/${pending3310_id}`),
      );
      this.pending_3310_records = this.pending_3310_records.filter(
        (r) => r._id !== pending3310_id,
      );
    } catch (error: any) {
      console.error('Failed to delete pending 3310 record:', error);
    }
  }

  private displayPdfInOverlay(blobUrl: string, form4473: Form4473) {
    // Remove existing overlay
    document.getElementById('pdf-4473-overlay')?.remove();

    const overlay = document.createElement('div');
    overlay.id = 'pdf-4473-overlay';
    overlay.style.cssText = `
    position:fixed; inset:0; background:rgba(0,0,0,0.95); z-index:9999;
    display:flex; flex-direction:column;
  `;

    const header = document.createElement('div');
    header.style.cssText = `
    background:#343a40; color:white; padding:15px 20px;
    display:flex; justify-content:space-between; align-items:center;
  `;

    const title = document.createElement('h5');
    title.textContent = 'Form 4473 PDF';
    title.style.cssText = 'margin:0; color:white;';

    const buttonGroup = document.createElement('div');
    buttonGroup.style.cssText = 'display:flex; gap:10px;';

    // Get proper filename
    const filename = `Form-4473_${
      form4473.transaction_serial_number || 'DRAFT'
    }.pdf`;

    // Download button
    const downloadBtn = document.createElement('a');
    downloadBtn.href = blobUrl;
    downloadBtn.download = filename;
    downloadBtn.innerHTML = '<i class="fa fa-download"></i> Download';
    downloadBtn.style.cssText = `
    padding:10px 20px; background:#28a745; color:white;
    border:none; border-radius:5px; cursor:pointer;
    text-decoration:none; display:flex; align-items:center; gap:5px; font-weight:bold;
  `;

    // Print button
    const printBtn = document.createElement('button');
    printBtn.innerHTML = '<i class="fa fa-print"></i> Print';
    printBtn.style.cssText = `
    padding:10px 20px; background:#007bff; color:white;
    border:none; border-radius:5px; cursor:pointer; font-weight:bold;
  `;
    printBtn.onclick = () => {
      const printFrame = document.createElement('iframe');
      printFrame.style.display = 'none';
      printFrame.src = blobUrl;
      document.body.appendChild(printFrame);
      printFrame.onload = () => {
        setTimeout(() => {
          printFrame.contentWindow?.print();
          setTimeout(() => printFrame.remove(), 1000);
        }, 500);
      };
    };

    // Close button
    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '<i class="fa fa-times"></i> Close';
    closeBtn.style.cssText = `
    padding:10px 20px; background:#dc3545; color:white;
    border:none; border-radius:5px; cursor:pointer; font-weight:bold;
  `;
    closeBtn.onclick = () => {
      overlay.remove();
      URL.revokeObjectURL(blobUrl);
      this.pdfOverlayClosedSource.next();
    };

    buttonGroup.appendChild(downloadBtn);
    buttonGroup.appendChild(printBtn);
    buttonGroup.appendChild(closeBtn);

    header.appendChild(title);
    header.appendChild(buttonGroup);

    // Create iframe container
    const pdfContainer = document.createElement('div');
    pdfContainer.style.cssText =
      'flex:1; position:relative; background:#525659;';

    // Use IFRAME instead of EMBED
    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.style.cssText = 'width:100%; height:100%; border:none;';

    // Track if iframe loaded
    let iframeLoaded = false;

    iframe.onload = () => {
      console.log('PDF iframe loaded successfully');
      iframeLoaded = true;
    };

    iframe.onerror = (e) => {
      console.error('Iframe failed to load:', e);
    };

    pdfContainer.appendChild(iframe);
    overlay.appendChild(header);
    overlay.appendChild(pdfContainer);
    document.body.appendChild(overlay);

    // Check if iframe loaded after delay
    setTimeout(() => {
      if (!iframeLoaded || iframe.contentDocument === null) {
        console.warn('PDF failed to load in iframe, showing fallback');
        const fallback = document.createElement('div');
        fallback.style.cssText = `
        position:absolute; inset:0; display:flex; flex-direction:column;
        justify-content:center; align-items:center; color:white; background:#525659;
        z-index:1;
      `;
        fallback.innerHTML = `
        <div style="text-align:center; padding:40px; background:white; border-radius:10px; color:#333; max-width:600px;">
          <i class="fa fa-file-pdf-o" style="font-size:64px; color:#dc3545; margin-bottom:20px;"></i>
          <h3>PDF Ready</h3>
          <p>Your browser cannot display PDFs inline.</p>
          <p style="margin-top:20px;">
            <strong>Please use the buttons above to:</strong><br>
            • <span style="color:#28a745; font-weight:bold;">Download</span> the PDF<br>
            • <span style="color:#007bff; font-weight:bold;">Print</span> directly<br>
          </p>
          <hr style="margin: 30px 0; border-color: #ddd;">
          <p style="font-size:12px; color:#666;">
            <span style="font-size:14px; color:#dc3545; font-weight:bold;">*** To enable inline viewing: ***</span><br>
            <div style="margin-top:10px; display:flex; align-items:center; justify-content:center; gap:5px;">
              <span style="font-size:13px;"><strong>1.</strong> Copy this URL:</span>
              <code id="chromeUrl" style="background:#f5f5f5; padding:4px 8px; border-radius:3px; cursor:pointer; user-select:all;" 
                    title="Click to select">chrome://settings/content/pdfDocuments</code>
              <button id="copyBtn" style="padding:4px 10px; background:#007bff; color:white; border:none; border-radius:3px; cursor:pointer; font-size:12px;">
                <i class="fa fa-copy"></i> Copy
              </button>
            </div>
            <span style="font-size:13px; display:block; margin-top:8px;"><strong>2.</strong> Paste it in your browser's address bar</span>
            <span style="font-size:13px;"><strong>3.</strong> Enable "Open PDFs in Chrome"</span>
          </p>
        </div>
      `;
        pdfContainer.appendChild(fallback);

        // Add copy functionality after appending to DOM
        const copyBtn = fallback.querySelector('#copyBtn');
        const chromeUrl = fallback.querySelector('#chromeUrl');

        if (copyBtn && chromeUrl) {
          copyBtn.addEventListener('click', () => {
            navigator.clipboard
              .writeText('chrome://settings/content/pdfDocuments')
              .then(() => {
                copyBtn.innerHTML = '<i class="fa fa-check"></i> Copied!';
                (copyBtn as HTMLElement).style.background = '#28a745';
                setTimeout(() => {
                  copyBtn.innerHTML = '<i class="fa fa-copy"></i> Copy';
                  (copyBtn as HTMLElement).style.background = '#007bff';
                }, 2000);
              })
              .catch((err) => {
                console.error('Failed to copy:', err);
              });
          });

          // Also allow clicking the code element to select all text
          chromeUrl.addEventListener('click', () => {
            const range = document.createRange();
            range.selectNodeContents(chromeUrl as Node);
            const selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
          });
        }
      }
    }, 2000);

    // Auto cleanup after 15 minutes
    setTimeout(() => {
      if (document.body.contains(overlay)) {
        overlay.remove();
      }
      URL.revokeObjectURL(blobUrl);
    }, 900000);
  }

  getFflEzCheck(
    licsRegn: string,
    licsDis: string,
    licsSeq: string,
  ): Observable<string> {
    const params = new HttpParams()
      .set('licsRegn', licsRegn)
      .set('licsDis', licsDis)
      .set('licsSeq', licsSeq);

    return this.http.get(`${this.apiUrl}/fflezcheck/fflSearch`, {
      responseType: 'text',
      params,
    });
  }

  searchFflByName(name: string): Observable<{ message: string; ffls: any[] }> {
    return this.http.get<{ message: string; ffls: any[] }>(
      `${this.apiUrl}/atf_ffl_lists/search/${name}`,
    );
  }

  searchFflByShort(
    first_character: string,
    second_third_characters: string,
    last_five_characters: string,
  ): Observable<{ message: string; ffls: any[] }> {
    return this.http.get<{ message: string; ffls: any[] }>(
      `${this.apiUrl}/atf_ffl_lists/search-short/${first_character}/${second_third_characters}/${last_five_characters}`,
    );
  }

  getAllAtfFflList(): Observable<{ message: string; atf_ffl_list: AtfFfl[] }> {
    return this.http
      .get<{
        message: string;
        atf_ffl_list: AtfFfl[];
      }>(`${this.apiUrl}/atf_ffl_lists`)
      .pipe(
        map((response) => {
          this.atf_ffl_list = response.atf_ffl_list || [];
          return response;
        }),
        catchError((error) => {
          console.error('Error fetching ATF FFL list', error);
          this.raiseErrorToast('Failed to retrieve ATF FFL list');
          return throwError(() => error);
        }),
      );
  }

  // * POST /api/bound_books/migrate/add-fields * Add company_id to all boundbook entries
  async migrateBoundBookAddCompanyId(): Promise<void> {
    const companyId = this.company_info.company_id;
    try {
      this.openStatusSpinner('Migrating bound book entries');

      const response = await firstValueFrom(
        this.http.post<{
          message: string;
          matchedCount: number;
          modifiedCount: number;
        }>(`${this.apiUrl}/bound_books/migrate/add-fields`, {
          company_id: companyId,
        }),
      );

      this.closeStatusSpinner();

      console.log(
        `Migration completed: ${response.modifiedCount} of ${response.matchedCount} documents updated`,
      );

      this.raiseSuccessToast(
        `Successfully updated ${response.modifiedCount} bound book entries`,
      );
    } catch (error: any) {
      this.closeStatusSpinner();
      console.error('Error migrating bound book entries:', error);
      this.raiseErrorToast('Failed to migrate bound book entries');
      throw error;
    }
  }

  //-----------Driver License CRUD Functions MongoDB-----------------
  async saveDriverLicense(license: DriverLicense): Promise<void> {
    try {
      const company_id = this.company_info.company_id;
      await firstValueFrom(
        this.http.post(`${this.apiUrl}/driver_licenses/save`, {
          company_id,
          license,
        }),
      );
      this.recent_drivers_license.push(license);
      this.raiseSuccessToast('Driver license saved successfully');
    } catch (error) {
      console.error('Error saving driver license:', error);
      // specific error handling if needed, but for now just log it
      // this.raiseErrorToast('Failed to save driver license');
    }
  }

  async getRecentDriverLicenses(): Promise<void> {
    try {
      const company_id = this.company_info.company_id;
      const response = await firstValueFrom(
        this.http.get<{ message: string; driver_licenses: DriverLicense[] }>(
          `${this.apiUrl}/driver_licenses/${company_id}`,
        ),
      );
      this.recent_drivers_license = response.driver_licenses || [];
      // Optionally emit an event if needed
    } catch (error) {
      console.error('Error retrieving recent driver licenses:', error);
    }
  }

  async deleteDriverLicense(license: DriverLicense): Promise<void> {
    try {
      const company_id = this.company_info.company_id;
      await firstValueFrom(
        this.http.delete(`${this.apiUrl}/driver_licenses/${license._id}`, {
          body: { company_id },
        }),
      );
      this.recent_drivers_license = this.recent_drivers_license.filter(
        (l) => l._id !== license._id,
      );
      this.raiseSuccessToast('Driver license deleted successfully');
    } catch (error) {
      console.error('Error deleting driver license:', error);
      // specific error handling if needed, but for now just log it
      // this.raiseErrorToast('Failed to delete driver license');
    }
  }
  openStatusSpinner(message: string): void {
    setTimeout(() => {
      this.loading_message = message;
      this.loading = true;
    });
  }
  closeStatusSpinner(): void {
    setTimeout(() => {
      this.loading = false;
    });
  }

  // Get last sync time for vendor inventory
  getVendorInventoryLastSync(): Observable<{ last_sync: string }> {
    return this.http.get<{ last_sync: string }>(
      `${this.apiUrl}/live_inventories/last-sync`,
    );
  }
}

export class CompetitorPricing {
  offer_id: string;
  name: string;
  price: number;
  vendor: string;
  shipping: string;
  url: string;
  is_available: boolean;
}
